import React, { useState, useEffect, useContext } from "react";
import { Badge, Button, Modal, Form, Card, Col, Row } from "react-bootstrap";
import "../../index.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { inWords, twoDecimalPlaces, uniqueID } from "../../utils/utilFuctions";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import {
  BASE_URL_API_TRANXT_UAT_API,
  BASE_URL_PAYNOW,
} from "../../utils/Constant";
import Select from "react-select";
import swal from "sweetalert";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaCheckCircle, FaChevronDown, FaFlag, FaTimes } from "react-icons/fa";
import { withLoader } from "../../utils/withLoader";
export const Viewsalaryslipemployee = ({ show, handleClose, employee }) => {
  // console.log(employee);
  const downloadPDF = () => {
    const input = document.getElementById("salaryslip-content");
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      const totalPageHeight = 297;
      const spaceToLeaveBelow = totalPageHeight * 0.25;
      const spaceToLeaveAbove = 10;
      const adjustedHeight =
        totalPageHeight - spaceToLeaveBelow - spaceToLeaveAbove;

      pdf.addImage(
        imgData,
        "PNG",
        0,
        spaceToLeaveAbove,
        pdfWidth,
        adjustedHeight,
      );

      pdf.save("salary_slip.pdf");
    });
  };

  const totalDeduction = () => {
    // console.log("Employee EPF:", employee?.epf, typeof employee?.epf);
    // console.log("Employee ESIC:", employee?.esic, typeof employee?.esic);

    const epfAmount = parseFloat(employee?.epf);
    if (!isNaN(epfAmount)) {
      const epfDeduction = epfAmount * 2;
      let totalDeductionAmount = epfDeduction;

      const esicAmount = parseFloat(employee?.esic);
      if (!isNaN(esicAmount)) {
        totalDeductionAmount += esicAmount;
      }

      return totalDeductionAmount;
    }

    return 0;
  };

  // console.log(totalDeduction());

  return (
    <Modal show={show} onHide={handleClose} className="salaryslip-modal">
      <Modal.Body>
        <div id="salaryslip-content">
          <form className="m-5">
            <div className="card p-0" style={{ border: "1px solid" }}>
              <div className="d-flex justify-content-end p-2">
                <img
                  alt=""
                  src={require("../../assets/images/pms/salary_logo.png")}
                  style={{ height: "2rem" }}
                />
              </div>
              <div>
                <h5 className="d-flex justify-content-center">
                  Bumppy Media Private Limited
                </h5>
                <h6 className="d-flex justify-content-center">
                  B-218,ITHUM Tower-B,2nd Floor, Sec-62, Noida, U.p-201301
                </h6>
              </div>
              <hr className="p-0 m-0" style={{ background: "#000" }} />
              <h6 className="d-flex justify-content-center">Salary Slip</h6>
              <hr className="p-0 m-0" style={{ background: "#000" }} />
              <div className="row">
                <div className="col">
                  {[
                    ["Emp Code", employee?.emp_code],
                    ["Name", employee?.name],
                    ["Designation", employee?.designation],
                    ["Department", employee?.department],
                    ["Bank Account No", employee?.bank_acc_no],
                    ["Bank IFSC", employee?.bank_ifsc],
                  ].map(([label, value], idx) => (
                    <div
                      key={idx}
                      className="row m-0 p-0 align-items-center mb-1"
                      style={{ fontSize: ".9rem", color: "#000" }}
                    >
                      <div className="col px-0 " style={{ fontWeight: "500" }}>
                        {label}:
                      </div>
                      <div className="col px-0">{value || "NA"}</div>
                    </div>
                  ))}
                </div>

                <div className="col">
                  {[
                    [
                      "Month",
                      [employee?.current_month, employee?.current_year]
                        .filter(Boolean)
                        .join(" "),
                    ],
                    ["ESI No", employee?.esic],
                    ["UAN", employee?.uan],
                    ["Pay Days", employee?.pay_days],
                    ["Salary Mode", "Bank Transfer"],
                    ["Bank Name", employee?.bank_name],
                  ].map(([label, value], idx) => (
                    <div
                      key={idx}
                      className="row m-0 p-0 align-items-center mb-1"
                      style={{ fontSize: ".9rem", color: "#000" }}
                    >
                      <div className="col px-0 " style={{ fontWeight: "500" }}>
                        {label}:
                      </div>
                      <div className="col px-0">{value || "NA"}</div>
                    </div>
                  ))}
                </div>
              </div>

              <hr className="m-0 p-0" style={{ background: "#000" }} />
              <table className="m-0" style={{ border: "none" }}>
                <thead>
                  <tr>
                    <th
                      style={{
                        background: "#fff",
                        color: "#000",
                        fontWeight: "400",
                        borderRight: "1px solid black",
                      }}
                      colSpan={2}
                    >
                      Standard Wages Amount
                    </th>
                    {/* <th style={{background:"#fff", color:"#000", fontWeight:"400", borderRight:"1px solid black"}}></th> */}
                    <th
                      style={{
                        background: "#fff",
                        color: "#000",
                        fontWeight: "400",
                        borderRight: "1px solid black",
                      }}
                    >
                      Earned Wages Amount
                    </th>
                    <th
                      style={{
                        background: "#fff",
                        color: "#000",
                        fontWeight: "400",
                        borderRight: "1px solid black",
                      }}
                    >
                      Deduction
                    </th>
                    <th
                      style={{
                        background: "#fff",
                        color: "#000",
                        fontWeight: "400",
                      }}
                    >
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody style={{ borderRight: "none", borderLeft: "none" }}>
                  <tr>
                    <td
                      style={{
                        border: "1px solid black",
                        fontSize: ".9rem",
                        borderLeft: "none",
                      }}
                    >
                      Basic
                    </td>
                    <td
                      style={{
                        fontSize: ".9rem",
                        border: "none",
                        borderTop: "1px solid",
                        borderRight: "1px solid ",
                      }}
                    >
                      {twoDecimalPlaces(employee?.basic || "NA")}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        fontSize: ".9rem",
                        borderTop: "1px solid",
                      }}
                    >
                      {twoDecimalPlaces(employee?.basic || "NA")}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        verticalAlign: "top",
                        fontSize: ".9rem",
                      }}
                    >
                      EPF
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        fontSize: ".9rem",
                        borderRight: "none",
                      }}
                    >
                      {twoDecimalPlaces(employee?.epf)}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        border: "1px solid black",
                        fontSize: ".9rem",
                        borderLeft: "none",
                      }}
                    >
                      HRA
                    </td>
                    <td
                      style={{ border: "1px solid black", fontSize: ".9rem" }}
                    >
                      {twoDecimalPlaces(employee?.hra || "NA")}
                    </td>
                    <td
                      style={{ border: "1px solid black", fontSize: ".9rem" }}
                    >
                      {twoDecimalPlaces(employee?.hra || "NA")}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        verticalAlign: "top",
                        fontSize: ".9rem",
                      }}
                    >
                      ESIC
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        fontSize: ".9rem",
                        borderRight: "none",
                      }}
                    >
                      {employee?.esic || "NA"}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        border: "1px solid black",
                        fontSize: ".9rem",
                        borderLeft: "none",
                      }}
                    >
                      Travel Allowance
                    </td>
                    <td
                      style={{ border: "1px solid black", fontSize: ".9rem" }}
                    >
                      {twoDecimalPlaces(employee?.t_allowance || "NA")}
                    </td>
                    <td
                      style={{ border: "1px solid black", fontSize: ".9rem" }}
                    >
                      {twoDecimalPlaces(employee?.t_allowance || "NA")}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        verticalAlign: "top",
                        fontSize: ".9rem",
                      }}
                    >
                      TDS
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        fontSize: ".9rem",
                        borderRight: "none",
                      }}
                    >
                      {0}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        border: "1px solid black",
                        fontSize: ".9rem",
                        borderLeft: "none",
                      }}
                    >
                      Med. Allowance
                    </td>
                    <td
                      style={{ border: "1px solid black", fontSize: ".9rem" }}
                    >
                      {" "}
                      {twoDecimalPlaces(employee?.m_allowance || "NA")}
                    </td>
                    <td
                      style={{ border: "1px solid black", fontSize: ".9rem" }}
                    >
                      {twoDecimalPlaces(employee?.m_allowance || "NA")}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        verticalAlign: "top",
                        fontSize: ".9rem",
                      }}
                    >
                      Loan
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        fontSize: ".9rem",
                        borderRight: "none",
                      }}
                    >
                      {twoDecimalPlaces(employee?.loan_emi_amount || "NA")}
                    </td>
                  </tr>

                  <tr>
                    <td
                      style={{
                        border: "1px solid black",
                        fontSize: ".9rem",
                        borderLeft: "none",
                      }}
                    >
                      Oth. Allowance
                    </td>
                    <td
                      style={{ border: "1px solid black", fontSize: ".9rem" }}
                    >
                      {twoDecimalPlaces(employee?.other_allowance || "NA")}
                    </td>
                    <td
                      style={{ border: "1px solid black", fontSize: ".9rem" }}
                    >
                      {twoDecimalPlaces(employee?.other_allowance || "NA")}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        verticalAlign: "top",
                        fontSize: ".9rem",
                      }}
                    ></td>
                    <td
                      style={{
                        border: "1px solid black",
                        fontSize: ".9rem",
                        borderRight: "none",
                      }}
                    ></td>
                  </tr>
                  <tr>
                    {/* <td
                      style={{
                        border: "1px solid black",
                        fontSize: ".9rem",
                        borderLeft: "none",
                      }}
                    >
                      Total
                    </td>
                    <td
                      style={{ border: "1px solid black", fontSize: ".9rem" }}
                    >
                      {twoDecimalPlaces(employee?.totalSalarywithpf || "NA")}
                    </td>
                    <td
                      style={{ border: "1px solid black", fontSize: ".9rem" }}
                    >
                      {twoDecimalPlaces(employee?.totalSalarywithpf || "NA")}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        verticalAlign: "top",
                        fontSize: ".9rem",
                      }}
                    >
                      Total Deduction
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        fontSize: ".9rem",
                        borderRight: "none",
                      }}
                    >
                      {twoDecimalPlaces(employee?.epf)}
                    </td> */}
                    <td
                      style={{
                        border: "1px solid black",
                        fontSize: ".9rem",
                        borderLeft: "none",
                      }}
                    >
                      Total (with EPF)
                    </td>
                    <td
                      style={{ border: "1px solid black", fontSize: ".9rem" }}
                    >
                      {twoDecimalPlaces(
                        (parseFloat(employee?.totalSalarywithpf) || 0) +
                          (parseFloat(employee?.epf) || 0),
                      )}
                    </td>
                    <td
                      style={{ border: "1px solid black", fontSize: ".9rem" }}
                    >
                      {twoDecimalPlaces(
                        (parseFloat(employee?.totalSalarywithpf) || 0) +
                          (parseFloat(employee?.epf) || 0),
                      )}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        verticalAlign: "top",
                        fontSize: ".9rem",
                      }}
                    >
                      Total Deduction
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        fontSize: ".9rem",
                        borderRight: "none",
                      }}
                    >
                      {twoDecimalPlaces(parseFloat(employee?.epf) || 0)}
                    </td>
                  </tr>
                </tbody>

                <tfoot className="mb-md-2">
                  <tr>
                    <td
                      colspan="5"
                      style={{
                        border: "1px solid black",
                        borderRight: "none",
                        borderLeft: "none",
                      }}
                    >
                      <p
                        className="mb-2"
                        style={{ color: "#000", fontSize: ".8rem" }}
                      >
                        Total Payable Amount :{" "}
                        {twoDecimalPlaces(employee?.totalSalary || "NA")}
                      </p>
                      <p
                        className="mb-2"
                        style={{ color: "#000", fontSize: ".8rem" }}
                      >
                        Payable Amount in Words :{" "}
                        {employee?.totalSalary
                          ? inWords(Math.round(Number(employee.totalSalary)))
                          : "NA"}
                      </p>
                    </td>
                  </tr>
                </tfoot>
              </table>
              <hr className="mt-md-3" style={{ background: "#000" }} />
              <p className="px-1" style={{ color: "#000", fontSize: ".8rem" }}>
                This is a computer generated pay slip and does not required any
                signature or any company seal.
              </p>
            </div>
          </form>
        </div>
        <Button className="btn-sm mt-2" onClick={downloadPDF}>
          Download PDF
        </Button>
      </Modal.Body>
    </Modal>
  );
};
export const Addcategoryemployeemodal = ({
  show,
  hide,
  fetchExpenseCategories,
}) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const { password, username } = billpunchbasicauth;
  const [errors, setErrors] = useState({});

  const validate = (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!category) newErrors.category = "Category is required";
    if (!description) newErrors.description = "Description is required";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    setTransactionLoaderState(true);
    try {
      // console.log("submit form");
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmid: user.firm_id,
        empid: user.userid,
        category: category,
        discription: description,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/AddExpenseCategory`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        swal("Success", data.result, "success");
        hide();
        fetchExpenseCategories();
        setTransactionLoaderState(false);
      } else {
        swal("Error", data.result, "error");
        hide();
        fetchExpenseCategories();
      }
      console.log("Form submission completed.");
    } catch (error) {
      console.log("Error:", error);
    }
  };

  return (
    <Modal show={show} onHide={hide}>
      <Modal.Header closeButton>
        <Modal.Title>Add Category</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={validate}>
          <Form.Group className="custom-form-group" controlId="Category">
            <Form.Control
              type="text"
              name="Category"
              placeholder="Category"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              isInvalid={!!errors.category}
            />
            {errors.category && (
              <div
                style={{
                  color: "red",
                  fontSize: "0.8rem",
                  marginTop: "0.25rem",
                }}
              >
                {errors.category}
              </div>
            )}
          </Form.Group>
          <Form.Group className="custom-form-group" controlId="description">
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              placeholder="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              isInvalid={!!errors.description}
            />
            {errors.description && (
              <div
                style={{
                  color: "red",
                  fontSize: "0.8rem",
                  marginTop: "0.25rem",
                }}
              >
                {errors.description}
              </div>
            )}
          </Form.Group>
          <Modal.Footer className="m-0 p-0">
            <div className="row">
              <div className="col-auto m-0 p-0 ml-auto">
                <button
                  className="d-flex align-items-center bg-primary p-1"
                  style={{
                    height: "2rem",
                    borderRadius: ".3rem",
                    fontSize: ".9rem",
                    color: "#fff",
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export const Addfixedexpenseemployeemodal = ({
  show,
  hide,
  expenseCategories,
  fetchFixedExpense,
}) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [category, setCategory] = useState("");
  const [amount, setAmount] = useState("");
  const { password, username } = billpunchbasicauth;
  const [errors, setErrors] = useState({});

  const validate = (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!category) newErrors.category = "Category is required";
    if (!amount) newErrors.amount = "Amount is required";
    if (amount && isNaN(amount)) newErrors.amount = "Amount must be a number";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    setTransactionLoaderState(true);
    try {
      // console.log("submit form");
      const base64Credentials = btoa(`${username}:${password}`);
      var raw = JSON.stringify({
        empid: user.userid,
        expensetype: category,
        amount: amount,
        firmid: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/AddMonthlyFixedExpense`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        swal("Success", data.result, "success");
        hide();
        fetchFixedExpense();
        setTransactionLoaderState(false);
      } else {
        swal("Error", data.result, "error");
        hide();
        fetchFixedExpense();
      }
      console.log("Form submission completed.");
    } catch (error) {
      console.log("Error:", error);
    }
  };

  return (
    <Modal show={show} onHide={hide}>
      <Modal.Header closeButton>
        <Modal.Title>Add Category</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={validate}>
          <Form.Group className="col custom-form-group" controlId="category">
            <Form.Label>Category</Form.Label>
            <Form.Control
              as="select"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              isInvalid={!!errors.category}
            >
              <option value="">Select Category</option>
              {expenseCategories.map((category) => (
                <option key={category.cat_id} value={category.category}>
                  {category.category}
                </option>
              ))}
            </Form.Control>
            {errors.category && (
              <div
                style={{
                  color: "red",
                  fontSize: "0.8rem",
                  marginTop: "0.25rem",
                }}
              >
                {errors.category}
              </div>
            )}
          </Form.Group>
          <div className="row">
            <Form.Group className="col-6 custom-form-group" controlId="amount">
              <Form.Control
                type="text"
                name="amount"
                placeholder="Amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                isInvalid={!!errors.amount}
              />
              {errors.amount && (
                <div
                  style={{
                    color: "red",
                    fontSize: "0.8rem",
                    marginTop: "0.25rem",
                  }}
                >
                  {errors.amount}
                </div>
              )}
            </Form.Group>
            <div className="col-4">
              <button
                className="d-flex align-items-center bg-primary p-1"
                style={{
                  borderRadius: ".3rem",
                  color: "#fff",
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export const Adddataemployeemodal = ({ show, hide, fetchMoneymanagement }) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [amount, setAmount] = useState("");
  const { password, username } = billpunchbasicauth;
  const [errors, setErrors] = useState({});

  const validate = (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!name) newErrors.name = "Name is required";
    if (!date) newErrors.date = "Date is required";
    if (!amount) newErrors.amount = "Amount is required";
    if (amount && isNaN(amount)) newErrors.amount = "Amount must be a number";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    setTransactionLoaderState(true);
    try {
      // console.log("submit form");
      const base64Credentials = btoa(`${username}:${password}`);
      var raw = JSON.stringify({
        empid: user.userid,
        firmid: user.firm_id,
        name: name,
        date: date,
        amount: amount,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/AddMoneyManagement`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        swal("Success", data.result, "success");
        hide();
        fetchMoneymanagement();
        setTransactionLoaderState(false);
      } else {
        swal("Error", data.result, "error");
        hide();
        fetchMoneymanagement();
      }
      console.log("Form submission completed.");
    } catch (error) {
      console.log("Error:", error);
    }
  };

  return (
    <Modal show={show} onHide={hide}>
      <Modal.Header closeButton>
        <Modal.Title>Money Management</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={validate}>
          <div className="row">
            <Form.Group className="col custom-form-group" controlId="name">
              <Form.Control
                type="text"
                name="name"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                isInvalid={!!errors.name}
              />
              {errors.name && (
                <div
                  style={{
                    color: "red",
                    fontSize: "0.8rem",
                    marginTop: "0.25rem",
                  }}
                >
                  {errors.name}
                </div>
              )}
            </Form.Group>
            <Form.Group className="col custom-form-group" controlId="date">
              <Form.Control
                type="date"
                name="date"
                placeholder="Date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                isInvalid={!!errors.date}
              />
              {errors.date && (
                <div
                  style={{
                    color: "red",
                    fontSize: "0.8rem",
                    marginTop: "0.25rem",
                  }}
                >
                  {errors.date}
                </div>
              )}
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="col-6 custom-form-group" controlId="amount">
              <Form.Control
                type="text"
                name="amount"
                placeholder="Amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                isInvalid={!!errors.amount}
              />
              {errors.amount && (
                <div
                  style={{
                    color: "red",
                    fontSize: "0.8rem",
                    marginTop: "0.25rem",
                  }}
                >
                  {errors.amount}
                </div>
              )}
            </Form.Group>
            <div className="col-4">
              <button
                className="d-flex align-items-center bg-primary p-1"
                style={{
                  height: "2rem",
                  borderRadius: ".3rem",
                  fontSize: ".9rem",
                  color: "#fff",
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export const SalaryExpenseEmployeeModal = ({ isOpen, closeModal }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [expenseCategories, setExpenseCategories] = useState([]);
  const [Project, setProject] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const { password, username } = billpunchbasicauth;
  const initialFormData = {
    project: "",
    Expensename: "",
    category: "",
    expenseDate: "",
    Amount: "",
    description: "",
  };

  const initialErrors = {
    project: "",
    Expensename: "",
    category: "",
    expenseDate: "",
    Amount: "",
    description: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState(initialErrors);

  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const validate = (e) => {
    e.preventDefault();
    // console.log("validate function");
    // console.log(formData);

    let errors = {};
    if (formData.project.trim() === "") {
      errors.project = "*Please enter Project Name";
    }

    if (formData.Expensename.trim() === "") {
      errors.Expensename = "*Please enter Expense Name";
    }

    if (formData.category.trim() === "") {
      errors.category = "*Please select Expense Type";
    }

    if (formData.expenseDate.trim() === "") {
      errors.expenseDate = "*Please enter Expense Date";
    }

    if (formData.Amount.trim() === "") {
      errors.Amount = "*Please enter Amount";
    }

    if (formData.description.trim() === "") {
      errors.description = "*Please enter Description";
    }

    setErrors(errors);
    console.log(errors);

    if (Object.keys(errors).length === 0) {
      handleSubmit();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "project" && value === "createProject") {
      openaddprojectModal();
      return;
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [addcategorymodal, setaddcategorymodal] = useState(false);
  const openExpensecatModal = () => {
    setaddcategorymodal(true);
  };

  const closeExpensecalModal = () => {
    setaddcategorymodal(false);
    setFormData({ ...formData, category: "" });
  };

  const fetchExpenseCategories = async () => {
    setIsLoading(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmid: user.firm_id,
        empid: user.userid,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetAllFirmExpenseCategories
            `,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setExpenseCategories(data.data);
      }
    } catch (error) {
      console.log("error", error);
    }
    setIsLoading(false);
  };

  const convertToByteArray = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onloadend = (evt) => {
        if (evt.target.readyState === FileReader.DONE) {
          const arrayBuffer = evt.target.result;
          const array = new Uint8Array(arrayBuffer);
          const binary = [...array]
            .map((byte) => String.fromCharCode(byte))
            .join("");
          const byteArray = window.btoa(binary);
          resolve(byteArray);
        }
      };
      reader.onerror = reject;
    });
  };

  const handleSubmit = async (cardType) => {
    setTransactionLoaderState(true);
    if (!selectedFile) {
      swal("Error", "Please select a file for upload.", "warning");
      return;
    }

    const uploadedFile = selectedFile;
    const byteArray = await convertToByteArray(uploadedFile);

    let imageType;
    if (uploadedFile.type === "application/pdf") {
      imageType = ".pdf";
    } else if (uploadedFile.type.startsWith("image/jpeg")) {
      imageType = ".jpeg";
    } else {
      swal(
        "Error",
        "Unsupported file type. Please upload a PDF or JPEG file.",
        "warning",
      );
      return;
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      image_type: imageType,
    }));
    const base64Credentials = btoa(`${username}:${password}`);

    try {
      const byteArray = await convertToByteArray(uploadedFile);
      const fileData = byteArray;

      const fileType = uploadedFile.type.split("/")[1];

      const requestBody = {
        userid: "BILL PUNCH",
        image_type: "expense",
        file_type: fileType,
        image_data: fileData,
      };

      const response = await fetch(
        "https://bumppy.in/billpunch/api/v1/imageUpload.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        },
      );

      const responseData = await response.json();

      if (responseData.status === "0") {
        const imageUrl = responseData.image_url;
        setFormData((prevFormData) => ({
          ...prevFormData,
          imageUrl: imageUrl,
        }));

        // Now submit the form with imageUrl
        const raw = JSON.stringify({
          firmid: user.firm_id,
          empid: user.userid,
          expense_type: formData.category,
          expense_date: formData.expenseDate,
          expense_amount: formData.Amount,
          approved_by_hr: "P",
          approved_by_admin: "P",
          image_name: formData.Expensename,
          image_type: imageType,
          description: formData.description,
          image_bytedata: byteArray,
          project_id: formData.project,
          baseurl: imageUrl, // Include imageUrl here
        });

        const requestOptions = {
          method: "POST",
          body: raw,
          redirect: "follow",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        };

        try {
          const response = await fetch(
            `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/insertExpenseDetails`,
            requestOptions,
          );
          const result = await response.json();

          if (result.status === "0") {
            setTransactionLoaderState(false);
            swal("Success", result.msg, "success");
            closeModal(false);
            setFormData(initialFormData);
          } else {
            setTransactionLoaderState(false);
            swal("Failed", result.msg, "error");
            closeModal(false);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        swal("Error", responseData.msg, "error");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      swal("Error", "Failed to upload file.", "error");
    }
  };
  const handleFileChange = async (e) => {
    setTransactionLoaderState(true);
    const file = e.target.files[0];

    if (!file) {
      swal("Error", "Please select a file for upload.", "warning");
      return;
    }

    if (file.type !== "image/jpeg" && file.type !== "image/png") {
      swal(
        "Error",
        "Unsupported file type. Please upload a JPEG or PNG file.",
        "error",
      );
      return;
    }

    try {
      const byteArray = await convertToByteArray(file);
      const fileData = byteArray;

      const fileType = file.type.split("/")[1];

      const requestBody = {
        userid: "BILL PUNCH",
        image_type: "expense",
        file_type: fileType,
        image_data: fileData,
      };

      const response = await fetch(
        "https://bumppy.in/billpunch/api/v1/imageUpload.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        },
      );

      const responseData = await response.json();

      if (responseData.status === "0") {
        const imageUrl = responseData.image_url;
        setFormData((prevFormData) => ({
          ...prevFormData,
          imageUrl: imageUrl,
        }));
        setSelectedFile(file);

        swal("Success", responseData.msg, "success");
        setTransactionLoaderState(false);
      } else {
        swal("Error", responseData.msg, "error");
        setTransactionLoaderState(false);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      swal("Error", "Failed to upload file.", "error");
    }
  };

  useEffect(() => {
    fetchExpenseCategories();
  }, []);
  useEffect(() => {
    if (!isOpen) {
      setFormData(initialFormData);
      setErrors(initialErrors);
    }
  }, [isOpen]);
  const fetchproject = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        empid: user.userid,
        firmid: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetProjectByEmployee
            `,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setProject(data.data);
      }
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };
  useEffect(() => {
    fetchproject();
  }, []);
  const [showaddprojectModal, setshowaddprojectModal] = useState(false);
  const openaddprojectModal = () => {
    setshowaddprojectModal(true);
  };

  const closeaddprojectModal = () => {
    setshowaddprojectModal(false);
  };
  return (
    <>
      <Expensecategoryemployeemodal
        showModal={addcategorymodal}
        closeModal={closeExpensecalModal}
        fetchExpenseCategories={fetchExpenseCategories}
      />
      <AddProjectemployeeModal
        show={showaddprojectModal}
        closeModal={closeaddprojectModal}
        getProjects={fetchproject}
      />
      <Modal show={isOpen} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add Expense Manually</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="mx-md-3 mx-sm-2">
            <div className="row m-0 p-1">
              {" "}
              <Form.Group className="col">
                <Form.Label> Select Project</Form.Label>
                <select
                  name="project"
                  className="form-control"
                  value={formData.project}
                  onChange={handleInputChange}
                >
                  <option value="">Select a Project</option>
                  <option value="createProject">+ Create Project</option>
                  {Project.map((project) => (
                    <option
                      key={project.pk_project_id}
                      value={project.pk_project_id}
                    >
                      {project.project_name}
                    </option>
                  ))}
                </select>

                {errors.project && (
                  <p className="text-danger">{errors.project}</p>
                )}
              </Form.Group>
            </div>
            <div className="row m-0 p-1">
              <Form.Group className="col">
                <Form.Label>Expense Name</Form.Label>
                <Form.Control
                  type="text"
                  name="Expensename"
                  value={formData.Expensename}
                  onChange={handleInputChange}
                  placeholder="Expense Name"
                />
                {errors.Expensename && (
                  <p className="text-danger">{errors.Expensename}</p>
                )}
              </Form.Group>{" "}
              <Form.Group className="col">
                <Form.Label>Expense Type</Form.Label>
                <Form.Control
                  as="select"
                  name="category"
                  value={formData.category}
                  onChange={(e) => {
                    handleInputChange(e);
                    if (e.target.value === "Add Category") {
                      openExpensecatModal();
                    }
                  }}
                >
                  <option value="">Category</option>
                  <hr />
                  <option>Add Category</option> <hr />
                  {isLoading ? (
                    <option>Loading...</option>
                  ) : (
                    expenseCategories.map((category) => (
                      <option
                        key={category.pk_expense_category_id}
                        value={category.category_name}
                      >
                        {category.category_name}
                      </option>
                    ))
                  )}
                </Form.Control>

                {errors.category && (
                  <p className="text-danger">{errors.category}</p>
                )}
              </Form.Group>
            </div>
            <div className="row m-0 p-1 ">
              <Form.Group className="col-6">
                <Form.Label> Amount:</Form.Label>
                <Form.Control
                  type="text"
                  name="Amount"
                  value={formData.Amount}
                  onChange={handleInputChange}
                  placeholder="Amount"
                />
                {errors.Amount && (
                  <p className="text-danger">{errors.Amount}</p>
                )}
              </Form.Group>
              <Form.Group className="col ">
                <Form.Label>Expense Date:</Form.Label>
                <Form.Control
                  type="date"
                  name="expenseDate"
                  value={formData.expenseDate}
                  onChange={handleInputChange}
                  placeholder=""
                />
                {errors.expenseDate && (
                  <p className="text-danger">{errors.expenseDate}</p>
                )}
              </Form.Group>
            </div>

            <div className="row m-0 p-1 ">
              <Form.Group className="col">
                <Form.Label>Description</Form.Label>
                <textarea
                  className="form-control"
                  type="textarea"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  placeholder="Description"
                />
                {errors.description && (
                  <p className="text-danger">{errors.description}</p>
                )}
              </Form.Group>
            </div>
            <div className="row m-0 p-1 ">
              <Form.Group className="col-8">
                <Form.Label>File Upload (PDF or JPEG)</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf, .jpeg, .jpg"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </div>

            <div className="row m-0 p-1 ">
              <div className="col-3">
                <button
                  className="btn btn-success d-flex align-items-center"
                  type="button"
                  style={{
                    height: "2rem",
                    borderRadius: ".3rem",
                    fontSize: ".8rem",
                  }}
                  onClick={validate}
                >
                  Submit
                </button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};
export const Expensecategoryemployeemodal = ({
  showModal,
  closeModal,
  fetchExpenseCategories,
}) => {
  const [Project, setProject] = useState([]);
  const { password, username } = billpunchbasicauth;
  const initialFormData = {
    project: "",
    category: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "project") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        project: value,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };
  const fetchproject = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmid: user.firm_id,
        created_by: "Employee",
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetFirmProjects
            `,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setProject(data.data);
      }
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };
  const handleSubmit = async (e) => {
    // console.log("abhi", handleSubmit);
    try {
      setTransactionLoaderState(true);
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmid: user.firm_id,
        empid: user.userid,
        type: "Emp",
        projectid: formData.project,
        category_name: formData.category,
      });

      // console.log("Request sending:", raw);

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };
      // console.log("sending data to abhijeet");
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/AddExpenseCategoriesEmp`,
        requestOptions,
      );
      // console.log("Api url");
      const data = await res.json();
      // console.log("nishant", data);
      if (data.status === "1") {
        swal("Error", data.msg, "error");
        setTransactionLoaderState(false);
        fetchExpenseCategories();
        closeModal();
      } else {
        swal("Success", data.msg, "success");
        setTransactionLoaderState(false);
        fetchExpenseCategories();
        closeModal();
      }
      console.log("Form submission completed.");
    } catch (error) {
      console.log("Error:", error);
    }
  };
  useEffect(() => {
    fetchproject();
  }, []);
  useEffect(() => {
    if (!showModal) {
      setFormData(initialFormData);
    }
  }, [showModal]);
  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      className="d-flex align-items-center"
    >
      <Modal.Header closeButton>
        <Modal.Title>Add Category</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div className="row">
            <Form.Group className="col">
              <Form.Label> Select Project</Form.Label>
              <Form.Control
                as="select"
                name="project"
                value={formData.project}
                onChange={handleInputChange}
              >
                <option value="">Select Project</option>
                {Project.length === 0 ? (
                  <option>No data found</option>
                ) : (
                  Project.map((project) => (
                    <option
                      key={project.pk_project_id}
                      value={project.pk_project_id}
                    >
                      {project.project_name}
                    </option>
                  ))
                )}
              </Form.Control>
            </Form.Group>
            <Form.Group className="col">
              <Form.Label>Expense Name</Form.Label>
              <Form.Control
                type="text"
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                placeholder="Category Name"
              />
            </Form.Group>{" "}
          </div>

          <button
            className="btn btn-success d-flex align-items-center"
            type="button"
            style={{
              height: "2rem",
              borderRadius: ".3rem",
              fontSize: ".8rem",
            }}
            onClick={handleSubmit}
          >
            Submit
          </button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export const AddProjectemployeeModal = ({ show, closeModal, getProjects }) => {
  const [Member, setMember] = useState([]);
  const [Employeeid, setEmployeeid] = useState(-1);
  const { password, username } = billpunchbasicauth;

  const [selectedEmployee, setselectedEmployee] = useState("");
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [projectfield, setProjectfields] = useState({
    Projectname: "",
    Projectownership: "",
    Projectstartdate: "",
    Projectenddate: "",
    Projectdescription: "",
  });
  const [projecterror, setProjecterror] = useState({
    Projectname: "",
    Projectownership: "",
    Projectstartdate: "",
    Projectenddate: "",
    Projectdescription: "",
  });
  const resetForm = () => {
    setProjectfields({
      Projectname: "",
      Projectownership: "",
      Projectstartdate: "",
      Projectenddate: "",
      Projectdescription: "",
    });
    setProjecterror({
      Projectname: "",
      Projectownership: "",
      Projectstartdate: "",
      Projectenddate: "",
      Projectdescription: "",
    });
    setselectedEmployee("");
  };
  const validate = (e) => {
    e.preventDefault();
    let errors = {};
    const spaceRegex = /^\s+/;

    if (spaceRegex.test(projectfield.Projectname)) {
      errors.Projectname = "*Project Name should not start with a space";
    } else if (projectfield.Projectname.trim() === "") {
      errors.Projectname = "*Please enter Project Name";
    }

    if (!selectedEmployee) {
      errors.Projectownership = "*Please select an employee";
    }

    if (spaceRegex.test(projectfield.Projectstartdate)) {
      errors.Projectstartdate = "*Date should not start with a space";
    } else if (projectfield.Projectstartdate.trim() === "") {
      errors.Projectstartdate = "*Please enter date";
    }

    if (spaceRegex.test(projectfield.Projectdescription)) {
      errors.Projectdescription = "*Description should not start with a space";
    } else if (projectfield.Projectdescription.trim() === "") {
      errors.Projectdescription = "*Please enter Description";
    }

    setProjecterror(errors);

    if (Object.keys(errors).length === 0) {
      handleSubmit();
      resetForm();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProjectfields((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleEmployeeSelection = (selectedOption) => {
    setselectedEmployee(selectedOption);
    setProjectfields((prevFormData) => ({
      ...prevFormData,
      Projectownership: selectedOption ? selectedOption.label : "",
      Employeeid: selectedOption ? selectedOption.value : -1,
    }));
  };

  const handleSubmit = async (e) => {
    // console.log("abhi", handleSubmit);
    try {
      setTransactionLoaderState(true);
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        project_name: projectfield.Projectname,
        project_ownership: projectfield.Projectownership,
        project_startdate: projectfield.Projectstartdate,
        project_enddate: projectfield.Projectenddate,
        project_discription: projectfield.Projectdescription,
        fk_firmid: user.firm_id,
        ownership_empid: projectfield.Employeeid,
        created_by: "Employee",
      });

      // console.log("Request sending:", raw);

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };
      // console.log("sending data to abhijeet");
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/InsertFirmProjects`,
        requestOptions,
      );
      // console.log("Api url");
      const data = await res.json();
      // console.log("nishant", data);
      if (data.status === "1") {
        swal("Error", data.msg, "error");
        setTransactionLoaderState(false);
        getProjects();
        closeModal();
      } else {
        swal("Success", data.msg, "success");
        setTransactionLoaderState(false);
        getProjects();
        closeModal();
      }
      console.log("Form submission completed.");
    } catch (error) {
      console.log("Error:", error);
    }
  };
  const GetFirmEmployee = async (e) => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmId: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployee`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        const mappedEmployees = data.data.map((employee) => ({
          value: employee.empid,
          label: `${employee.firstname} ${employee.lastname}`,
        }));
        setMember(mappedEmployees);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };
  useEffect(() => {
    GetFirmEmployee();
  }, []);
  const handleClose = () => {
    closeModal();
    resetForm();
  };
  const today = new Date().toISOString().split("T")[0];
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="">Add Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={validate}>
            <div className="row">
              {" "}
              <Form.Group className="col-6 m-0">
                <Form.Label> Project Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Project Name"
                  id="Projectname"
                  name="Projectname"
                  value={projectfield.Projectname}
                  onChange={handleChange}
                />
                {projecterror.Projectname && (
                  <p className="text-danger">{projecterror.Projectname}</p>
                )}
              </Form.Group>
              <Form.Group className="col-6 m-0">
                <Form.Label> Owner Name</Form.Label>
                <Select
                  options={Member}
                  value={selectedEmployee}
                  onChange={handleEmployeeSelection}
                  placeholder="Select Name"
                />
                {projecterror.Projectownership && (
                  <p className="text-danger">{projecterror.Projectownership}</p>
                )}
              </Form.Group>
            </div>
            <div className="row">
              {" "}
              <Form.Group className="col-6 m-0">
                <Form.Label> Start Date</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Start Date"
                  id="Projectstartdate"
                  name="Projectstartdate"
                  value={projectfield.Projectstartdate}
                  onChange={handleChange}
                />
                {projecterror.Projectstartdate && (
                  <p className="text-danger">{projecterror.Projectstartdate}</p>
                )}
              </Form.Group>
              <Form.Group className="col-6 m-0">
                <Form.Label> End Date</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="End Date"
                  id="Projectenddate"
                  name="Projectenddate"
                  value={projectfield.Projectenddate}
                  onChange={handleChange}
                  min={today}
                />
                {projecterror.Projectenddate && (
                  <p className="text-danger">{projecterror.Projectenddate}</p>
                )}
              </Form.Group>
            </div>
            <div className="row ">
              <Form.Group className="col">
                <Form.Label>Description</Form.Label>
                <textarea
                  className="form-control"
                  type="textarea"
                  name="Projectdescription"
                  value={projectfield.Projectdescription}
                  onChange={handleChange}
                  placeholder="Project Description"
                />
                {projecterror.Projectdescription && (
                  <p className="text-danger">
                    {projecterror.Projectdescription}
                  </p>
                )}
              </Form.Group>
            </div>
            <div className="col-4 ">
              <button
                // type="submit"
                type="button"
                className="btn btn-primary btn-block d-flex justify-content-center align-items-center"
                style={{ height: "2rem", borderRadius: ".3rem" }}
                onClick={validate}
              >
                Add Project
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};
export const FetchBillModalEmployee = ({
  setFetchBillModal,
  fetchBillModal,
  payBill,
  billDetails,
  billerResponse,
  callback,
  billPayResponse,
  setAmount,
  amount,
  setTpin,
  Tpin,
  config,
}) => {
  const { password, username } = billpunchbasicauth;

  const [tpinShow, setTpinShow] = useState(false);
  const [PayClicked, setPayClicked] = useState(false);
  const openInNewTab = (data) => {
    localStorage.setItem("print", JSON.stringify(data));
    const CLIENT = "";
    const newWindow = window.open(
      `${CLIENT}/pages/bbps/print`,
      "",
      "height=600,width=800'",
    );
    if (newWindow) newWindow.opener = null;
  };

  const showTPinClick = () => {
    setTpinShow(!tpinShow);
  };
  return (
    <Modal show={fetchBillModal} onHide={setFetchBillModal}>
      <Modal.Header closeButton>
        <Modal.Title>Fetch Bill</Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{ width: "100%", display: "block" }}
        className="account m-0 p-0"
      >
        {billDetails && !billPayResponse && (
          <Card style={{ margin: "10px", padding: "10px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <img
                src={require("../../assets/images/BBPSSidebarLogo.png")}
                style={{
                  width: "auto",
                  height: "1.2rem",
                  backgroundColor: "whitesmoke",
                }}
              />
              <img
                onClick={() => {
                  openInNewTab(billDetails);
                }}
                style={{ height: "1.5rem" }}
                src={require("../../assets/icons/print_1.png")}
              />
            </div>
            <table style={{ border: "none", fontFamily: "-webkit-body" }}>
              <tr style={{ background: "none", border: "none" }}>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  Name
                </td>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  {billDetails.billerResponse.customerName}
                </td>
              </tr>
              <tr style={{ background: "none" }}>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  Bill Number
                </td>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  {billDetails.billerResponse.billNumber}
                </td>
              </tr>
              <tr style={{ background: "none" }}>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  Amount
                </td>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  {amount}
                </td>
              </tr>

              {/* Additional Info */}
              {billDetails.additionalInfo &&
                billDetails.additionalInfo.length > 0 &&
                billDetails.additionalInfo.map((info) => (
                  <tr style={{ background: "none" }}>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "0.8rem",
                      }}
                    >
                      {info.name}
                    </td>
                    <td
                      style={{
                        paddingLeft: "1rem",
                        border: "none",
                        background: "none",
                        width: "50%",
                        fontSize: "0.8rem",
                      }}
                    >
                      {info.value}
                    </td>
                  </tr>
                ))}

              <tr style={{ background: "none" }}>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  Bill date
                </td>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  {billDetails.billerResponse.billDate}
                </td>
              </tr>

              <tr style={{ background: "none" }}>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  Due Date.
                </td>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  {billDetails.billerResponse.dueDate}
                </td>
              </tr>
              <tr style={{ background: "none" }}>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  Reference Id
                </td>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  {billDetails.refId}
                </td>
              </tr>

              {config.amountEditable && (
                <tr style={{ background: "none" }}>
                  <td
                    style={{
                      paddingLeft: "1rem",
                      border: "none",
                      background: "none",
                      width: "50%",
                      fontSize: "0.8rem",
                    }}
                  >
                    {" "}
                    Amount
                  </td>
                  <td
                    style={{
                      paddingLeft: "1rem",
                      border: "none",
                      background: "none",
                      width: "50%",
                      fontSize: "0.8rem",
                    }}
                  >
                    <Form.Control
                      type="number"
                      className="form-control rounded-0"
                      aria-label="Notes"
                      aria-describedby="basic-addon1"
                      placeholder={`Enter Amount`}
                      onChange={(e) => {
                        setAmount(e.target.value);
                      }}
                      value={amount}
                    />
                  </td>
                </tr>
              )}

              <tr style={{ background: "none" }}>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  T Pin
                </td>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  <div className="input-group">
                    <div className="input-group-prepend bg-transparent">
                      <span className="input-group-text bg-transparent border-right-0 no-glow">
                        <i className="mdi mdi-lock-outline text-primary"></i>
                      </span>
                    </div>
                    <input
                      autocomplete="new-password"
                      autoCorrect="off"
                      autoSave="new-password"
                      type={tpinShow ? "text" : "password"}
                      className="form-control form-control-lg border-left-0 border-right-0 no-glow"
                      id="exampleInputPassword"
                      placeholder={`Enter T Pin`}
                      onChange={(e) => {
                        setTpin(e.target.value);
                      }}
                      value={Tpin}
                    />
                    <div className="input-group-prepend bg-transparent">
                      <span
                        className="input-group-text bg-transparent border-left-0 no-glow"
                        onClick={showTPinClick}
                        style={{ borderRadius: "4px" }}
                      >
                        <i
                          className={`mdi text-primary ${
                            tpinShow ? "mdi-eye" : "mdi-eye-off"
                          }`}
                        ></i>
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
            <div
              style={{
                padding: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {PayClicked ? (
                <Button className="rounded-0" variant="success">
                  {" "}
                  Paying ...
                </Button>
              ) : (
                <Button
                  className="rounded-0"
                  variant="success"
                  onClick={callback}
                >
                  {" "}
                  Pay Bill
                </Button>
              )}
            </div>
          </Card>
        )}
        {billDetails && billPayResponse && (
          <Card style={{ margin: "10px", padding: "10px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <img
                src={require("../../assets/images/BBPSSidebarLogo.png")}
                style={{
                  width: "auto",
                  height: "1.2rem",
                  backgroundColor: "whitesmoke",
                }}
              />
              <img
                onClick={() => {
                  openInNewTab(billDetails);
                }}
                style={{ height: "1.5rem" }}
                src={require("../../assets/icons/print_1.png")}
              />
            </div>
            <table style={{ border: "none", fontFamily: "-webkit-body" }}>
              <tr style={{ background: "none", border: "none" }}>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  Name
                </td>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  {billDetails.billerResponse.customerName}
                </td>
              </tr>

              {billDetails.billerResponse.billNumber && (
                <tr style={{ background: "none" }}>
                  <td
                    style={{
                      paddingLeft: "1rem",
                      border: "none",
                      background: "none",
                      width: "50%",
                      fontSize: "0.8rem",
                    }}
                  >
                    {" "}
                    Bill Number
                  </td>
                  <td
                    style={{
                      paddingLeft: "1rem",
                      border: "none",
                      background: "none",
                      width: "50%",
                      fontSize: "0.8rem",
                    }}
                  >
                    {" "}
                    {billDetails.billerResponse.billNumber}
                  </td>
                </tr>
              )}

              <tr style={{ background: "none" }}>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  Amount
                </td>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  {amount}
                </td>
              </tr>

              <tr style={{ background: "none" }}>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  Reference Id
                </td>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  {billPayResponse.refId}
                </td>
              </tr>
              <tr style={{ background: "none" }}>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  Transaction Reference Id
                </td>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  {billPayResponse.txnReferenceId}
                </td>
              </tr>

              <tr style={{ background: "none" }}>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  {" "}
                  Status
                </td>
                <td
                  style={{
                    paddingLeft: "1rem",
                    border: "none",
                    background: "none",
                    width: "50%",
                    fontSize: "0.8rem",
                  }}
                >
                  <span className="badge badge-pill badge-success p-3">
                    {billPayResponse.responseReason}
                  </span>
                </td>
              </tr>
            </table>
          </Card>
        )}
      </Modal.Body>
    </Modal>
  );
};
export const AddBillFormEmployee = ({
  showModal,
  handleCloseModal,
  getAllPropertyBills,
}) => {
  const { password, username } = billpunchbasicauth;

  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const servicesOption = [
    {
      value: 1,
      label: "Broadband Postpaid",
    },
    {
      value: 2,
      label: "Cable TV",
    },
    {
      value: 3,
      label: "DTH",
    },
    {
      value: 4,
      label: "Education Fees",
    },
    {
      value: 5,
      label: "Electricity",
    },
    {
      value: 6,
      label: "Fastag",
    },
    {
      value: 7,
      label: "Gas",
    },
    {
      value: 8,
      label: "Health Insurance",
    },
    {
      value: 9,
      label: "Hospital",
    },
    {
      value: 10,
      label: "Housing Society",
    },
    {
      value: 11,
      label: "Insurance",
    },
    {
      value: 12,
      label: "Landline Postpaid",
    },
    {
      value: 13,
      label: "Life Insurance",
    },
    {
      value: 14,
      label: "Loan Repayment",
    },
    {
      value: 15,
      label: "LPG Gas",
    },
    {
      value: 16,
      label: "Mobile Postpaid",
    },
    {
      value: 17,
      label: "Municipal Services",
    },
    {
      value: 18,
      label: "Municipal Taxes",
    },
    {
      value: 19,
      label: "Subscription",
    },
    {
      value: 20,
      label: "Water",
    },
    {
      value: 21,
      label: "Clubs and Associations",
    },
    {
      value: 22,
      label: "Credit Card",
    },
    {
      value: 23,
      label: "Hospital and Pathology",
    },
    {
      value: 24,
      label: "Mobile Prepaid",
    },
    {
      value: 25,
      label: "Recurring Deposit",
    },
    {
      value: 26,
      label: "Travel Agency",
    },
  ];

  // console.log("Service options:", servicesOption);

  const [service, setService] = useState("1");

  // console.log("Service state:", service);
  const [CustP, setCustP] = useState([]);

  // console.log("CustP state:", CustP);

  const [providers, setProviders] = useState([]);
  // console.log("Providers state:", providers);

  const [formData, setFormData] = useState({
    Service: "1",
    Provider: "",
    ConsumerId: "",
    Mobile: "",
    Amount: "",
  });
  console.log("FormData state:", formData);

  const [billerResponse, setBillerResponse] = useState({
    msg: "",
    success: "",
    error: [],
  });
  console.log("BillerResponse state:", billerResponse);

  const [state, setState] = useState({
    provider: "",
    consumer: "",
    mobileNumber: "",
    custparams: "",
  });
  console.log("State state:", state);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "Service") {
      setService(value);
    }

    console.log("Form data after change:", formData);
  };
  const { Profileinfo } = useContext(GlobalContext);
  console.log("User from context:", user);
  console.log("Profileinfo from context:", Profileinfo);

  const handleSubmit = async (e) => {
    console.log("Submit button clicked");
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmid: user.firm_id,
        service: formData.Service.label,
        provider: state.provider.value,
        consumerid: CustP[0].value,
        paramsList: JSON.stringify(CustP),
        refno: "string",
        mobile: Profileinfo?.mobile,
        month: new Date().toISOString(),
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/addfirmBill`,
        requestOptions,
      );

      const data = await res.json();
      console.log("nishant", data);
      if (data.status === "1") {
        swal("Error", data.msg, "error");
        handleCloseModal();
        getAllPropertyBills();
      } else {
        sessionStorage.setItem("params", JSON.stringify(CustP));
        swal("Success", data.msg, "success");
        handleCloseModal();
        getAllPropertyBills();
      }
      setTransactionLoaderState(false);
      console.log("Form submission completed.");
    } catch (error) {
      console.log("Error:", error);
    }
    setTransactionLoaderState(false);
  };

  const fetchAllProviders = async () => {
    console.log("Fetching providers started");
    setTransactionLoaderState(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Basic IHJham5lZXNoQGV4YW1wbGUuY29tIDogVGVzdEAxMjM0NQ==",
      );
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userName: "string",
        categoryId: formData.Service.value,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_PAYNOW}/api/Operator/GetAllOperators`,
        requestOptions,
      );
      const data = await res.json();
      if (data.responseCode === "00") {
        const modifiedProviders = data.data.map((e) => {
          return { ...e, label: e.billerName, value: e.billerId };
        });
        console.log("Fetched providers data:", data.data);
        console.log("Modified providers:", modifiedProviders);

        setProviders(modifiedProviders);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("Error fetching providers:", error);
    }
    setTransactionLoaderState(false);
  };
  console.log("Providers:", providers);

  console.log(providers);

  useEffect(() => {
    fetchAllProviders();
  }, [formData.Service]);

  useEffect(() => {
    if (state.provider) {
      setCustP(
        state.provider.customerParams.map((param, i) => {
          return { ...param, id: i, value: "" };
        }),
      );
    }

    console.log("CustP after state.provider change:", CustP);
  }, [state]);

  console.log("CustP after useEffect:", CustP);

  console.log("CustP JSON:", JSON.stringify(CustP));

  return (
    <>
      <div>
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title className="mx-md-3">Add Bill</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form className="m-md-2 ">
              <div className="row">
                <Form.Group className="col-6">
                  <Form.Label style={{ color: "black" }}> Services</Form.Label>
                  <Select
                    options={servicesOption}
                    value={formData.Service}
                    onChange={(e) => {
                      setFormData({ ...formData, Service: e });
                    }}
                  ></Select>
                </Form.Group>

                <Form.Group className="col-6">
                  <Form.Label style={{ color: "black" }}>Provider</Form.Label>
                  <Select
                    options={providers}
                    value={state.provider}
                    onChange={(e) => {
                      setState({
                        ...state,
                        provider: e,
                      });
                      setFormData({
                        ...formData,
                        Provider: e,
                      });
                    }}
                  />
                </Form.Group>
              </div>
              <div className="row">
                {CustP.map((cust, i) => (
                  <Form.Group key={cust.id} className="col-6 px-md-3 m-0 px-0">
                    {cust.optional == "true" ? (
                      <Form.Label>{`${cust.paramName} (optional)`}</Form.Label>
                    ) : (
                      <Form.Label>
                        <span style={{ color: "red" }}>*</span>
                        {` ${cust.paramName}`}
                      </Form.Label>
                    )}
                    <Form.Control
                      type="text"
                      className="form-control rounded-0"
                      aria-label="Notes"
                      aria-describedby="basic-addon1"
                      placeholder={`Enter ${cust.paramName}`}
                      onChange={(e) => {
                        setBillerResponse({
                          ...billerResponse,
                          error: [],
                          msg: "",
                        });
                        const copy = [...CustP];
                        copy.forEach((ele) => {
                          if (ele.id == cust.id) {
                            ele.value = e.target.value;
                          }
                        });
                        setCustP(copy);
                      }}
                      value={cust.value}
                    />
                  </Form.Group>
                ))}
              </div>
              <div className="row">
                <Form.Group className="col-6">
                  <Form.Label style={{ color: "black" }}>Amount</Form.Label>
                  <input
                    type="text"
                    className="form-control "
                    id="Amount"
                    name="Amount"
                    value={formData.Amount}
                    onChange={handleChange}
                    placeholder="Enter Amount"
                  />
                </Form.Group>
                <div className="col-4  pt-md-3">
                  <button
                    // type="submit"
                    type="button"
                    className="btn btn-primary btn-block d-flex justify-content-center align-items-center"
                    style={{ height: "2.5rem", borderRadius: ".3rem" }}
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>{" "}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};
export const Addholidaymodal = ({
  formData,
  showModal,
  closeModal,
  handleFormChange,
  handleSubmit,
  setFormData,
  errors,
}) => {
  const handleCategoryChange = (event) => {
    setFormData({
      ...formData,
      category: event.target.value,
    });
  };
  const { password, username } = billpunchbasicauth;

  const handleCloseModal = () => {
    closeModal();

    setFormData({
      category: "",
      fromDate: "",
      toDate: "",
      discription: "",
    });
  };

  return (
    <Modal show={showModal} onHide={handleCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>Add Leave </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div className="row ">
            <Form.Group className="col" controlId="category">
              <Form.Label>Category</Form.Label>
              <select
                className="form-control"
                value={formData.category}
                onChange={handleCategoryChange}
              >
                <option value="">All Category</option>
                <option value="Casual"> Casual</option>
                <option value="Sick"> Sick</option>
                <option value="Out of station"> Out of station</option>
              </select>
              {errors.category && (
                <div className="text-danger">{errors.category}</div>
              )}
            </Form.Group>
            <Form.Group className="col" controlId="fromDate">
              <Form.Label>From Date</Form.Label>
              <Form.Control
                type="date"
                name="fromDate"
                value={formData.fromDate}
                onChange={handleFormChange}
              />
              {errors.fromDate && (
                <div className="text-danger">{errors.fromDate}</div>
              )}
            </Form.Group>
            <Form.Group className="col" controlId="toDate">
              <Form.Label>To Date</Form.Label>
              <Form.Control
                type="date"
                name="toDate"
                value={formData.toDate}
                onChange={handleFormChange}
              />
              {errors.toDate && (
                <div className="text-danger">{errors.toDate}</div>
              )}
            </Form.Group>
          </div>

          <Form.Group className="mx-md-2" controlId="discription">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              name="discription"
              value={formData.discription}
              placeholder="Reason for leave"
              onChange={handleFormChange}
            />
            {errors.discription && (
              <div className="text-danger">{errors.discription}</div>
            )}
          </Form.Group>
          <div className="mx-md-2">
            <Button
              className="d-flex align-items-center"
              type="submit"
              style={{
                height: "2rem",
                borderRadius: ".3rem",
                fontSize: ".9rem",
              }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export const EmployeeworspaceModal = ({
  isOpen,
  onClose,
  selectedWorkspaceId,
  getWorkspacedata,
  selectedProject,
}) => {
  const { password, username } = billpunchbasicauth;
  const [employees, setEmployees] = useState([]);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [employeetable, setemployeetable] = useState([]);

  const handleEmployeeChange = (selectedOption) => {
    setSelectedEmployeeId(selectedOption.value);
  };

  const getEmployees = async () => {
    setTransactionLoaderState(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Basic " + btoa(username + ":" + password),
      );

      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          firmId: user.firm_id,
        }),
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployee`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setEmployees(
          data.data.map((employee) => ({
            value: employee.empid,
            label: `${employee.firstname} ${employee.lastname}`,
          })),
        );
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const Getemployeetable = async () => {
    setTransactionLoaderState(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Basic " + btoa(username + ":" + password),
      );

      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ workid: selectedWorkspaceId }),
      };
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetEmployeeWorkspace`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setemployeetable(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedEmployeeId) {
      swal("Error", "No employee selected", "error");
      return;
    }

    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Basic " + btoa(username + ":" + password),
      );

      myHeaders.append("Content-Type", "application/json");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          workid: selectedWorkspaceId,
          empid: selectedEmployeeId,
          projectid: selectedProject,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/AddEmployeeWorkspace`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "1") {
        swal("Error", data.result, "error");
        Getemployeetable();
        getWorkspacedata();
      } else {
        swal("Success", data.result, "success");
        Getemployeetable();
        getWorkspacedata();
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    if (isOpen) {
      Getemployeetable();
    }
  }, [isOpen, selectedWorkspaceId]);
  useEffect(() => {
    getEmployees();
    Getemployeetable();
  }, []);

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Select Employee</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <Form.Group className="col" controlId="Employeename">
            <Form.Label>Select Employee</Form.Label>
            <Select options={employees} onChange={handleEmployeeChange} />
          </Form.Group>
          <div className="col d-flex align-items-center">
            {" "}
            <Button variant="success" onClick={handleSubmit}>
              Submit
            </Button>
          </div>
        </div>
        <div>
          <table className="table">
            <thead>
              <tr>
                <th
                  style={{
                    borderBottom: "1px solid #f2f4f2",
                    color: "#000",
                    padding: "8px",
                    textAlign: "left",
                    background: "#fff",
                  }}
                >
                  ID
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #f2f4f2",
                    color: "#000",
                    padding: "8px",
                    textAlign: "left",
                    background: "#fff",
                  }}
                >
                  Employee
                </th>
              </tr>
            </thead>
            <tbody>
              {employeetable.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    No Employee found.
                  </td>
                </tr>
              ) : (
                employeetable.map((empdata) => (
                  <tr key={empdata.empid}>
                    <td
                      style={{
                        textAlign: "left",
                        border: "none",
                        fontSize: ".9rem",
                      }}
                    >
                      {empdata.empid}
                    </td>
                    <td
                      style={{
                        textAlign: "left",
                        border: "none",
                        fontSize: ".9rem",
                      }}
                    >
                      {empdata.full_name}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        {/* Additional buttons */}
      </Modal.Footer>
    </Modal>
  );
};
export const EditTaskModal = ({
  showModal,
  handleClose,
  selectedTask,
  setSelectedTask,
  pk_project_id,
  pk_work_id,
  getTask,
}) => {
  console.log(pk_project_id);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;
  const [members, setMembers] = useState([]);

  const fetchMembers = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({ workid: pk_work_id });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetWorkEmployee`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0" && data.data) {
        const membersData = data.data.map((emp) => ({
          value: emp.empid,
          label: emp.fullname,
        }));
        setMembers(membersData);
      } else {
        setMembers([]);
      }
    } catch (error) {
      console.log("error", error);
      setMembers([]);
    }
  };

  const handleSave = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const selectedEmployee = members.find(
        (member) => member.value === selectedTask.task_empid,
      );
      const taskassigne = selectedEmployee
        ? selectedEmployee.label
        : "Not Assigned";

      // Extract date parts manually (Avoids timezone shift issue)
      const getFormattedDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      const formattedStartDate = getFormattedDate(selectedTask.task_startdate);
      const formattedEndDate = getFormattedDate(selectedTask.task_enddate);

      const raw = JSON.stringify({
        task_id: selectedTask.pk_taskid,
        project_id: pk_project_id,
        taskname: selectedTask.taskname,
        taskpriority: selectedTask.taskpriority,
        taskdesc: selectedTask.task_description,
        taskassigne: taskassigne,
        task_empid: selectedTask.task_empid,
        task_startdate: formattedStartDate,
        task_enddate: formattedEndDate,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/EditTaskEmployee`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "1") {
        swal("Error", data.result, "error");
      } else {
        swal("Success", data.result[0].message, "success");
        setTransactionLoaderState(false);
        getTask();
      }
      handleClose();
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const formatDateForInput = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    fetchMembers();
  }, [pk_work_id]);

  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Task</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedTask && (
          <Form>
            <div className="row m-0 p-0">
              <Form.Group className="col" controlId="formtaskname">
                <Form.Label>Task Name</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedTask.taskname}
                  onChange={(e) =>
                    setSelectedTask({
                      ...selectedTask,
                      taskname: e.target.value,
                    })
                  }
                />
              </Form.Group>
              <Form.Group className="col" controlId="formTaskAssignee">
                <Form.Label>Assignee</Form.Label>
                <Form.Control
                  as="select"
                  value={selectedTask.task_empid}
                  onChange={(e) =>
                    setSelectedTask({
                      ...selectedTask,
                      task_empid: e.target.value,
                    })
                  }
                >
                  <option value="">Select Employee</option>
                  {members.map((member) => (
                    <option key={member.value} value={member.value}>
                      {member.label}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </div>
            <div className="row m-0 p-0">
              <Form.Group className="col" controlId="formstrtTaskDate">
                <Form.Label>Start Date</Form.Label>
                <Form.Control
                  type="date"
                  value={
                    selectedTask.task_startdate
                      ? formatDateForInput(selectedTask.task_startdate)
                      : ""
                  }
                  onChange={(e) =>
                    setSelectedTask({
                      ...selectedTask,
                      task_startdate: e.target.value,
                    })
                  }
                />
              </Form.Group>
              <Form.Group className="col" controlId="formendTaskDate">
                <Form.Label>End Date</Form.Label>
                <Form.Control
                  type="date"
                  value={
                    selectedTask.task_enddate
                      ? formatDateForInput(selectedTask.task_enddate)
                      : ""
                  }
                  onChange={(e) =>
                    setSelectedTask({
                      ...selectedTask,
                      task_enddate: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </div>
            <div className="row m-0 p-0">
              <Form.Group className="col" controlId="formTaskStatus">
                <Form.Label>Status</Form.Label>
                <Form.Control
                  as="select"
                  value={selectedTask.status}
                  onChange={(e) =>
                    setSelectedTask({
                      ...selectedTask,
                      status: e.target.value,
                    })
                  }
                >
                  <option value="O">Overdue</option>
                  <option value="P">Pending</option>
                  <option value="C">Complete</option>
                </Form.Control>
              </Form.Group>
            </div>
            <div className="row m-0 p-0">
              <Form.Group className="col" controlId="formTaskDescription">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  type="text"
                  as="textarea"
                  rows={2}
                  value={selectedTask.task_description}
                  onChange={(e) =>
                    setSelectedTask({
                      ...selectedTask,
                      task_description: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </div>
          </Form>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export const Dependencytable = ({ show, closeModal, taskId }) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [dependencydata, setDependencyData] = useState([]);
  const { password, username } = billpunchbasicauth;

  const getDependency = async () => {
    setTransactionLoaderState(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username + ":" + password).toString("base64"),
      );
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        taskid: taskId,
      });
      console.log(taskId, "dependencytaskmodal");
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetTaskDependency`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setDependencyData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    console.log("New taskId:", taskId);
    getDependency();
  }, [taskId]);
  const [Removedependency, setRemovedependency] = useState(null);

  const RemoveTaskDependency = async (pk_did) => {
    const confirmed = await swal({
      title: "Are you sure?",
      text: "Are you sure to remove this dependency!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirmed) {
      setTransactionLoaderState(true);
      try {
        var myHeaders = new Headers();
        myHeaders.append(
          "Authorization",
          "Basic " + Buffer.from(username + ":" + password).toString("base64"),
        );
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
          empid: user.userid,
          did: pk_did,
          taskid: taskId,
        });

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const res = await fetch(
          `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/RemoveTaskDependency`,
          requestOptions,
        );
        const data = await res.json();
        if (data.status === "0") {
          swal("Success", data.result, "success");
          setRemovedependency(data.data);
          getDependency();
        }
        setTransactionLoaderState(false);
      } catch (error) {
        console.log("error", error);
        setTransactionLoaderState(false);
        getDependency();
      }
    }
  };
  const { accessData } = useContext(GlobalContext);
  useEffect(() => {
    console.log("Access Data:", accessData);
  }, [accessData]);

  return (
    <>
      <Modal show={show} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title className="">Dependency</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table">
            <thead>
              <tr>
                <th
                  style={{
                    borderBottom: "1px solid #f2f4f2",
                    color: "#000",
                    padding: "8px",
                    textAlign: "left",
                    background: "#fff",
                  }}
                >
                  Title
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #f2f4f2",
                    color: "#000",
                    padding: "8px",
                    textAlign: "left",
                    background: "#fff",
                  }}
                >
                  Desc.
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #f2f4f2",
                    color: "#000",
                    padding: "8px",
                    textAlign: "left",
                    background: "#fff",
                  }}
                >
                  Dependency
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #f2f4f2",
                    color: "#000",
                    padding: "8px",
                    textAlign: "left",
                    background: "#fff",
                  }}
                >
                  Date
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #f2f4f2",
                    color: "#000",
                    padding: "8px",
                    textAlign: "left",
                    background: "#fff",
                  }}
                >
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {dependencydata.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    No dependencies found.
                  </td>
                </tr>
              ) : (
                dependencydata.map((dependency) => (
                  <tr key={dependency.pk_did}>
                    <td
                      style={{
                        textAlign: "left",
                        border: "none",
                        fontSize: ".9rem",
                      }}
                    >
                      {dependency.dependency_tittle}
                    </td>
                    <td
                      style={{
                        textAlign: "left",
                        border: "none",
                        fontSize: ".9rem",
                      }}
                    >
                      {dependency.dependency_desc}
                    </td>
                    <td
                      style={{
                        textAlign: "left",
                        border: "none",
                        fontSize: ".9rem",
                      }}
                    >
                      {dependency.dependency_on}
                    </td>
                    <td
                      style={{
                        textAlign: "left",
                        border: "none",
                        fontSize: ".9rem",
                      }}
                    >
                      {new Date(dependency.date).toLocaleDateString("en-US")}
                    </td>
                    <td
                      style={{
                        textAlign: "left",
                        border: "none",
                        fontSize: ".9rem",
                      }}
                    >
                      {accessData &&
                        accessData.map(
                          (module) =>
                            module.data &&
                            module.data.map((role) =>
                              role.role_name === "Remove Dependency" ? (
                                <span key={role.pk_role_id}>
                                  {role.access === "Y" ? (
                                    <>
                                      {dependency.status === "Y" && (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <span
                                            className="p-1"
                                            style={{
                                              backgroundColor:
                                                "rgba(43, 193, 85, 0.1)",
                                              color: "#2bc155",
                                              border: "1px solid #2bc155",
                                              borderRadius: ".3rem",
                                            }}
                                          >
                                            Open
                                          </span>
                                          &nbsp;{" "}
                                          <FaTimes
                                            onClick={() =>
                                              RemoveTaskDependency(
                                                dependency.pk_did,
                                              )
                                            }
                                          />
                                        </div>
                                      )}

                                      {dependency.status === "N" && (
                                        <span
                                          className=" p-1 "
                                          style={{
                                            backgroundColor:
                                              "rgba(255, 46, 46, 0.1)",
                                            color: "#ff2e2e",
                                            border: "1px solid #ff2e2e",
                                            borderRadius: ".3rem",
                                          }}
                                        >
                                          Close
                                        </span>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {dependency.status === "Y" && (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <span
                                            className="p-1"
                                            style={{
                                              backgroundColor:
                                                "rgba(43, 193, 85, 0.1)",
                                              color: "#2bc155",
                                              border: "1px solid #2bc155",
                                              borderRadius: ".3rem",
                                              pointerEvents: "none", // Disable pointer events
                                              opacity: "0.5",
                                            }}
                                          >
                                            Open
                                          </span>
                                          &nbsp;{" "}
                                          <FaTimes
                                            onClick={() =>
                                              RemoveTaskDependency(
                                                dependency.pk_did,
                                              )
                                            }
                                          />
                                        </div>
                                      )}

                                      {dependency.status === "N" && (
                                        <span
                                          className=" p-1 "
                                          style={{
                                            backgroundColor:
                                              "rgba(255, 46, 46, 0.1)",
                                            color: "#ff2e2e",
                                            border: "1px solid #ff2e2e",
                                            borderRadius: ".3rem",
                                            pointerEvents: "none", // Disable pointer events
                                            opacity: "0.5",
                                          }}
                                        >
                                          Close
                                        </span>
                                      )}
                                    </>
                                  )}
                                </span>
                              ) : null,
                            ),
                        )}
                    </td>
                    {/* <td
                        style={{
                          textAlign: "left",
                          border: "none",
                          fontSize: ".9rem",
                        }}
                      >
                        {dependency.status === "Y" && (
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <span
                              className="p-1"
                              style={{
                                backgroundColor: "rgba(43, 193, 85, 0.1)",
                                color: "#2bc155",
                                border: "1px solid #2bc155",
                                borderRadius: ".3rem",
                              }}
                            >
                              Open
                            </span>
                            &nbsp;{" "}
                            <FaTimes
                              onClick={() =>
                                RemoveTaskDependency(dependency.pk_did)
                              }
                            />
                          </div>
                        )}
  
                        {dependency.status === "N" && (
                          <span
                            className=" p-1 "
                            style={{
                              backgroundColor: "rgba(255, 46, 46, 0.1)",
                              color: "#ff2e2e",
                              border: "1px solid #ff2e2e",
                              borderRadius: ".3rem",
                            }}
                          >
                            Close
                          </span>
                        )}
                      </td> */}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </Modal.Body>
      </Modal>
    </>
  );
};
export const DependencyModal = ({ show, closeModal, getTask }) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [Employee, setEmployee] = useState();
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    date: "",
    name: "",
  });
  const { password, username } = billpunchbasicauth;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const GetFirmEmployee = async () => {
    setTransactionLoaderState(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username + ":" + password).toString("base64"),
      );
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        firmid: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployee`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setEmployee(
          data.data.map((emp) => ({
            value: emp.firstname,
            label: emp.firstname,
          })),
        );
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };

  const dependencytaskid = JSON.parse(
    sessionStorage.getItem("dependencytaskid"),
  );
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setTransactionLoaderState(true);

      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username + ":" + password).toString("base64"),
      );
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        empid: user.userid,
        taskid: dependencytaskid.pk_taskid,
        tittle: formData.title,
        desc: formData.description,
        dependency_on: formData.name.value,
        date: formData.date,
      });

      console.log("Request sending:", raw);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      console.log("sending data to abhijeet");
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/AddTaskDependency`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "1") {
        swal("Error", data.result, "error");
        setTransactionLoaderState(false);
        getTask();
        closeModal();
      } else {
        swal("Success", data.result, "success");
        setTransactionLoaderState(false);
        getTask();
        closeModal();
      }
      console.log("Form submission completed.");
    } catch (error) {
      console.log("Error:", error);
    }
  };
  useEffect(() => {
    GetFirmEmployee();
  }, []);
  return (
    <>
      <Modal show={show} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title className="">Add Dependency</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <div className="row m-0 p-0">
              <Form.Group className="col" controlId="title">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  placeholder="Enter title"
                />
              </Form.Group>
            </div>
            <div className="row m-0 p-0">
              <Form.Group className="col" controlId="name">
                <Form.Label>Name</Form.Label>
                <Select
                  value={formData.name}
                  onChange={(selectedOption) =>
                    handleChange({
                      target: { name: "name", value: selectedOption },
                    })
                  }
                  options={Employee}
                  placeholder="Select Employee"
                />
              </Form.Group>

              <Form.Group className="col" controlId="date">
                <Form.Label>Date</Form.Label>
                <Form.Control
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>
            <div className="row m-0 p-0">
              <Form.Group className="col" controlId="description">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Enter description"
                />
              </Form.Group>
            </div>
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};
export const AddsubTask1employeeModal = ({
  show,
  closeModal,
  getSubsubTask,
  pk_work_id,
  pk_project_id,
}) => {
  const [Member, setMember] = useState([]);
  const [Category, setCategory] = useState([]);
  const [Platform, setPlatform] = useState([]);
  const [Employeeid, setEmployeeid] = useState(-1);
  const [platformId, setPlatformId] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const { password, username } = billpunchbasicauth;

  const [platformName, setPlatformName] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [projectfield, setProjectfields] = useState({
    Taskname: "",
    Taskassign: "",
    Taskdesc: "",
    Taskstrt: "",
    Taskend: "",
    TaskPrio: "",
    Resource: "",
  });
  const [projecterror, setProjecterror] = useState({
    Taskname: "",
    Taskassign: "",
    Taskdesc: "",
    Taskstrt: "",
    Taskend: "",
    Resource: "",
  });
  const validateForm = (e) => {
    e.preventDefault();
    let errors = {};
    let formIsValid = true;

    if (!projectfield.Taskname.trim()) {
      errors.Taskname = "*Task name is required";
      formIsValid = false;
    }

    if (!projectfield.Taskdesc.trim()) {
      errors.Taskdesc = "*Task description is required";
      formIsValid = false;
    }

    if (!projectfield.Taskstrt) {
      errors.Taskstrt = "*Start date is required";
      formIsValid = false;
    }

    if (!projectfield.Taskend) {
      errors.Taskend = "*End date is required";
      formIsValid = false;
    }

    if (projectfield.Taskstrt && projectfield.Taskend) {
      const startDate = new Date(projectfield.Taskstrt);
      const endDate = new Date(projectfield.Taskend);
      if (startDate > endDate) {
        errors.Taskend = "*End date cannot be before start date";
        formIsValid = false;
      }
    }

    // if (!taskEmpId) {
    //   errors.Taskassign = "*A task assignee must be selected";
    //   formIsValid = false;
    // }

    // if (!selectedMember) {
    //   errors.Resource = "*Resource is required";
    //   formIsValid = false;
    // }

    if (!projectfield.Taskname.trim()) {
      errors.Taskname = "*Task name is required";
      formIsValid = false;
    }

    if (!projectfield.Taskdesc.trim()) {
      errors.Taskdesc = "*Task description is required";
      formIsValid = false;
    }

    if (!projectfield.TaskPrio) {
      errors.TaskPrio = "*Priority is required";
      formIsValid = false;
    }

    if (!categoryId) {
      errors.categoryName = "*Category is required";
      formIsValid = false;
    }

    if (!platformId) {
      errors.platformName = "*Platform is required";
      formIsValid = false;
    }
    setProjecterror(errors);
    if (Object.keys(errors).length == 0) {
      handleSubmit();
    }
  };
  const handleChange = async (e) => {
    const { name, value } = e.target;
    setProjectfields((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const [members, setMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState("");
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [taskAssignee, setTaskAssignee] = useState("");
  const [taskEmpId, setTaskEmpId] = useState("");
  const [isAddCategoryModalOpen, setAddCategoryModalOpen] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");

  const fetchMembers = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({
        workid: pk_work_id,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetWorkEmployee`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0" && data.data) {
        const membersData = data.data.map((emp) => ({
          value: emp.empid,
          label: emp.fullname,
        }));
        setMembers(membersData);
      } else {
        setMembers([]);
      }
    } catch (error) {
      console.log("error", error);
      setMembers([]); // Ensure reset on error too
    }
  };

  const handleMemberChange = (selectedOption) => {
    setTaskAssignee(selectedOption.label);
    setTaskEmpId(selectedOption.value);
    setSelectedMember(selectedOption);
  };

  const options = [
    {
      value: "Urgent",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "maroon" }} />
          Urgent
        </div>
      ),
    },
    {
      value: "High",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "#f4c430" }} />
          High
        </div>
      ),
    },
    {
      value: "Normal",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "blue" }} />
          Normal
        </div>
      ),
    },
    {
      value: "Low",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "grey" }} />
          Low
        </div>
      ),
    },
    {
      value: "Clear",
      label: (
        <div>
          {" "}
          <img
            src={require("../../assets/images/flag_1.png")}
            style={{ marginRight: "5px", width: ".8rem" }}
          />
          Clear
        </div>
      ),
    },
  ];

  const handlePlatformSelection = (selectedPlatform) => {
    setPlatformName(selectedPlatform.label);
    setPlatformId(selectedPlatform.value);
  };

  const handleCategorySelection = (selectedCategory) => {
    if (selectedCategory.value === "add_category") {
      setAddCategoryModalOpen(true);
    } else {
      console.log("Selected Category:", selectedCategory);
      setCategoryName(selectedCategory.label);
      setCategoryId(selectedCategory.value);
    }
  };
  const [uploadedfeatureImageUrl, setUploadedfeatureImageUrl] = useState(null);

  const handlefeatureImageUpload = async (event) => {
    const files = Array.from(event.target.files);
    for (const file of files) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const binaryData = reader.result;
        const filename1 = file.name;
        setTransactionLoaderState(true);
        try {
          const response = await fetch(
            `https://billpunch.com/api/uploadissue.php?filename=${encodeURIComponent(
              filename1,
            )}`,
            {
              method: "POST",
              body: binaryData,
              headers: {
                "Content-Type": "application/octet-stream",
              },
            },
          );

          const result = await response.json();

          if (result.status === "success") {
            const imageUrl = result.file_url;

            setUploadedfeatureImageUrl(imageUrl);

            swal({
              title: "Success!",
              text: `File uploaded successfully. URL: ${imageUrl}`,
              icon: "success",
              button: "OK",
            });
            setTransactionLoaderState(false);
          } else {
            swal({
              title: "Error!",
              text: result.message,
              icon: "error",
              button: "OK",
            });
            setTransactionLoaderState(false);
          }
        } catch (error) {
          setTransactionLoaderState(false);
          swal({
            title: "Error!",
            text: `Upload failed: ${error.message}`,
            icon: "error",
            button: "OK",
          });
        }
      };

      reader.readAsArrayBuffer(file);
    }
  };
  const handleSubmit = async (e) => {
    try {
      setTransactionLoaderState(true);

      const selectedEmployee = Member.find(
        (employee) => employee.value === Employeeid,
      );
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        spaceid: pk_work_id,
        projectid: pk_project_id,
        firmid: user.firm_id,
        taskname: projectfield.Taskname,
        taskpriority: projectfield.TaskPrio,
        taskdesc: projectfield.Taskdesc,
        taskassigne: user.username,
        task_empid: user.userid,
        task_startdate: projectfield.Taskstrt,
        task_endate: projectfield.Taskend,
        status: "P",
        dependency_status: "N",
        platform: platformName,
        category: categoryName,
        issue: uploadedfeatureImageUrl,
      });

      console.log("Request sending:", raw);

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };
      console.log("sending data to abhijeet");
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/AddTaskEmployee`,
        requestOptions,
      );
      console.log("Api url");
      const data = await res.json();
      console.log("nishant", data);
      if (data.status === "1") {
        swal("Error", data.result, "error");
        setTransactionLoaderState(false);
        getSubsubTask();
        closeModal();
      } else {
        swal("Success", data.result, "success");
        setTransactionLoaderState(false);
        getSubsubTask();
        handleClose();
      }
      console.log("Form submission completed.");
    } catch (error) {
      console.log("Error:", error);
    }
  };
  const Getcatogory = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firmid: user.firm_id,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetCatTask`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        const categories = data.data.map((cat) => ({
          value: cat.pk_catid,
          label: cat.catname,
        }));
        setCategory(categories);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("error", error);
      setTransactionLoaderState(false);
    }
  };

  const Getplatform = async () => {
    setTransactionLoaderState(true);
    try {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          taskid: "string",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetTaskPlatform`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        const platformdata = data.data.map((device) => ({
          value: device.pk_platformid,
          label: device.platform_name,
        }));
        setPlatform(platformdata);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("error", error);
      setTransactionLoaderState(false);
    }
  };
  const handleClose = () => {
    setProjectfields({
      Taskname: "",
      Taskassign: "",
      Taskdesc: "",
      Taskstrt: "",
      Taskend: "",
      TaskPrio: "",
      Resource: "",
    });
    setSelectedMember(null);
    setTaskAssignee("");
    setTaskEmpId("");
    setPlatformId("");
    setCategoryId("");
    setPlatformName("");
    setCategoryName("");
    closeModal();
  };
  const handleAddCategory = async () => {
    if (!newCategoryName.trim()) {
      swal("Error", "Category name cannot be empty", "error");
      return;
    }

    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({
        category: newCategoryName,
        category_desc: "string",
        firmid: user.firm_id,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/InsertTaskCategoryV1`,
        requestOptions,
      );

      const data = await res.json();
      if (data.status === "0") {
        swal("Success", data.result[0].message, "success");
        setAddCategoryModalOpen(false);
        setNewCategoryName("");
        Getcatogory();
      } else {
        swal("Error", data.result, "error");
      }
    } catch (error) {
      console.error("Error adding category:", error);
    }
  };
  useEffect(() => {
    Getcatogory();
    Getplatform();
    fetchMembers();
  }, []);
  const categoryOptions = [
    { value: "add_category", label: "➕ Add Category" },
    ...Category,
  ];
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="">Add Task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row m-0 p-0">
              <div className="form-group">
                <Form.Label htmlFor="imageTitle">Upload Image </Form.Label>
                <Form.Control
                  type="file"
                  id="image-upload"
                  accept="image/*"
                  multiple
                  onChange={handlefeatureImageUpload}
                />
              </div>
              {/* <Form.Group className="col custom-form-group">
                <Form.Label> Select Resource</Form.Label>
                <Select
                  id="memberDropdown"
                  value={selectedMember}
                  onChange={handleMemberChange}
                  options={members}
                  placeholder="Select Member"
                />
                {projecterror.Resource && (
                  <div className="text-danger">{projecterror.Resource}</div>
                )}
              </Form.Group> */}
            </div>
            <div className="row m-0 p-0">
              <Form.Group className="col-6 m-0 custom-form-group">
                <Form.Label> Task Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Task Name"
                  id="Taskname"
                  name="Taskname"
                  value={projectfield.Taskname}
                  onChange={handleChange}
                />
                {projecterror.Taskname && (
                  <div className="text-danger">{projecterror.Taskname}</div>
                )}
              </Form.Group>
              <Form.Group className="col custom-form-group">
                <Form.Label>Priority</Form.Label>
                <Select
                  options={options}
                  onChange={(option) =>
                    setProjectfields((prevFormData) => ({
                      ...prevFormData,
                      TaskPrio: option.value,
                    }))
                  }
                  placeholder=" Priority"
                />
                {projecterror.TaskPrio && (
                  <div className="text-danger">{projecterror.TaskPrio}</div>
                )}
              </Form.Group>
            </div>
            <div className="row m-0 p-0">
              <Form.Group className="col custom-form-group">
                <Form.Label>Category</Form.Label>
                <Select
                  options={categoryOptions}
                  onChange={handleCategorySelection}
                  placeholder="Select Category"
                />
                {projecterror.categoryName && (
                  <div className="text-danger">{projecterror.categoryName}</div>
                )}
              </Form.Group>
              <Form.Group className="col custom-form-group">
                <Form.Label>Platform</Form.Label>
                <Select
                  onChange={handlePlatformSelection}
                  options={Platform}
                  placeholder=" Platform"
                />
                {projecterror.platformName && (
                  <div className="text-danger">{projecterror.platformName}</div>
                )}
              </Form.Group>
            </div>
            <div className="row m-0 p-0 mb-3">
              {" "}
              <Form.Group className="col-6 custom-form-group m-0">
                <Form.Label> Start Date</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Start Date"
                  id="Taskstrt"
                  name="Taskstrt"
                  value={projectfield.Taskstrt}
                  onChange={handleChange}
                />
                {projecterror.Taskstrt && (
                  <p className="text-danger">{projecterror.Taskstrt}</p>
                )}
              </Form.Group>
              <Form.Group className="col-6 custom-form-group m-0">
                <Form.Label> End Date</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="End Date"
                  id="Taskend"
                  name="Taskend"
                  value={projectfield.Taskend}
                  onChange={handleChange}
                />
                {projecterror.Taskend && (
                  <p className="text-danger">{projecterror.Taskend}</p>
                )}
              </Form.Group>
            </div>

            <div className="row m-0 p-0">
              <Form.Group className="col custom-form-group">
                <Form.Label>Description</Form.Label>
                <textarea
                  className="form-control"
                  type="textarea"
                  name="Taskdesc"
                  value={projectfield.Taskdesc}
                  onChange={handleChange}
                  placeholder="Project Description"
                />
                {projecterror.Taskdesc && (
                  <div className="text-danger">{projecterror.Taskdesc}</div>
                )}
              </Form.Group>
            </div>
            <div className="col-4 mx-2 ">
              <button
                type="submit"
                // type="button"
                className="btn btn-primary btn-block d-flex justify-content-center align-items-center"
                style={{ height: "2rem", borderRadius: ".3rem" }}
                onClick={validateForm}
              >
                Add Task
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <Modal
        show={isAddCategoryModalOpen}
        onHide={() => setAddCategoryModalOpen(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label>Category Name</label>
            <input
              type="text"
              className="form-control"
              value={newCategoryName}
              onChange={(e) => setNewCategoryName(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            size="sm"
            variant="secondary"
            onClick={() => setAddCategoryModalOpen(false)}
          >
            Close
          </Button>
          <Button size="sm" variant="primary" onClick={handleAddCategory}>
            Add Category
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export const AddsubTaskemployeeModal = ({
  show,
  closeModal,
  getSubsubTask,
  setshowaddsubtaskModal,
}) => {
  const [Member, setMember] = useState([]);
  const [Category, setCategory] = useState([]);
  const [selectedplaformid, setSelectedplaformid] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState([]);
  const { password, username } = billpunchbasicauth;

  const [Platform, setPlatform] = useState([]);
  const [Employeeid, setEmployeeid] = useState(-1);
  const [selectedEmployee, setselectedEmployee] = useState("");
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [projectfield, setProjectfields] = useState({
    Taskname: "",
    Taskassign: "",
    Taskdesc: "",
    Taskstrt: "",
    Taskend: "",
    TaskPrio: "",
  });
  const [projecterror, setProjecterror] = useState({
    Taskname: "",
    Taskassign: "",
    Taskdesc: "",
    Taskstrt: "",
    Taskend: "",
  });
  const [isAddCategoryModalOpen, setAddCategoryModalOpen] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProjectfields((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleEmployeeSelection = (selectedOption) => {
    setselectedEmployee(selectedOption);
    setEmployeeid(selectedOption ? selectedOption.value : -1);
    setProjectfields((prevFormData) => ({
      ...prevFormData,
      Taskassign: selectedOption ? selectedOption.label : "",
      task_empid: selectedOption ? selectedOption.value : "string",
    }));
  };
  const WorkDashID = JSON.parse(sessionStorage.getItem("property"));

  const GetFirmEmployee = async (e) => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        workid: WorkDashID.pk_work_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetWorkEmployee`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        const mappedEmployees = data.data.map((employee) => ({
          value: employee.empid,
          label: employee.fullname,
        }));
        setMember(mappedEmployees);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };
  const Getcatogory = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firmid: user.firm_id,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetCatTask`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        const categories = data.data.map((cat) => ({
          value: cat.pk_catid,
          label: cat.catname,
        }));
        setCategory(categories);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("error", error);
      setTransactionLoaderState(false);
    }
  };
  const Getplatform = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          taskid: "string",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetTaskPlatform`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        const platformdata = data.data.map((device) => ({
          value: device.pk_platformid,
          label: device.platform_name,
        }));
        setPlatform(platformdata);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("error", error);
      setTransactionLoaderState(false);
    }
  };
  const handleCategorySelection = (selectedCategory) => {
    if (selectedCategory.value === "add_category") {
      setAddCategoryModalOpen(true);
    } else {
      setSelectedCategoryId(selectedCategory.value);
      console.log("Selected Category:", selectedCategory);
    }
  };
  const handlePlatformSelection = (selectedOption) => {
    setSelectedplaformid(selectedOption ? selectedOption.value : "");
  };
  useEffect(() => {
    GetFirmEmployee();
    Getcatogory();
    Getplatform();
  }, []);

  const options = [
    {
      value: "Urgent",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "maroon" }} />
          Urgent
        </div>
      ),
    },
    {
      value: "High",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "#f4c430" }} />
          High
        </div>
      ),
    },
    {
      value: "Normal",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "blue" }} />
          Normal
        </div>
      ),
    },
    {
      value: "Low",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "grey" }} />
          Low
        </div>
      ),
    },
    {
      value: "Clear",
      label: (
        <div>
          {" "}
          <img
            src={require("../../assets/images/flag_1.png")}
            style={{ marginRight: "5px", width: ".8rem" }}
          />
          Clear
        </div>
      ),
    },
  ];
  useEffect(() => {
    if (!show) {
      resetFormFields();
    }
  }, [show]);

  const resetFormFields = () => {
    setProjectfields({
      Taskname: "",
      Taskassign: "",
      Taskdesc: "",
      Taskstrt: "",
      Taskend: "",
      TaskPrio: "",
    });
    setProjecterror({
      Taskname: "",
      Taskassign: "",
      Taskdesc: "",
      Taskstrt: "",
      Taskend: "",
    });
    setselectedEmployee("");
    setEmployeeid(-1);
    setSelectedplaformid([]);
    setSelectedCategoryId([]);
  };
  const taskdetails = JSON.parse(sessionStorage.getItem("taskdetails"));
  const handleSubmit = async (e) => {
    console.log(handleSubmit, "selectedEmployee");

    e.preventDefault();
    try {
      setTransactionLoaderState(true);

      const selectedEmployee = Member.find(
        (employee) => employee.value === Employeeid,
      );
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        fk_taskid: String(taskdetails.pk_taskid),
        sub_name: String(projectfield.Taskname),
        sub_empname: String(selectedEmployee.label),
        sub_empid: String(Employeeid),
        subtask_desc: String(projectfield.Taskdesc),
        sub_startdate: String(projectfield.Taskstrt),
        sub_enddate: String(projectfield.Taskend),
        status: "P",
        extra: "string",
        priority: String(projectfield.TaskPrio),
        platform_id: String(selectedplaformid),
        category_id: String(selectedCategoryId),
      });

      console.log("Request sending:", raw);

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };
      console.log("sending data to abhijeet");
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/AddSubTasks`,
        requestOptions,
      );
      console.log("Api url");
      const data = await res.json();
      console.log("nishant", data);
      if (data.status === "1") {
        swal("Error", data.result, "error");
        setTransactionLoaderState(false);
        // getSubsubTask();
        setshowaddsubtaskModal(false);
      } else {
        swal("Success", data.result, "success");
        setTransactionLoaderState(false);
        // getSubsubTask();
        setshowaddsubtaskModal(false);
        Getcatogory();
        resetFormFields();
      }
      console.log("Form submission completed.");
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const handleAddCategory = async () => {
    if (!newCategoryName.trim()) {
      swal("Error", "Category name cannot be empty", "error");
      return;
    }

    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({
        category: newCategoryName,
        category_desc: "string",
        firmid: user.firm_id,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/InsertTaskCategoryV1`,
        requestOptions,
      );

      const data = await res.json();
      if (data.status === "0") {
        swal("Success", data.result[0].message, "success");
        setAddCategoryModalOpen(false);
        setNewCategoryName("");
        Getcatogory();
      } else {
        swal("Error", data.result, "error");
      }
    } catch (error) {
      console.error("Error adding category:", error);
    }
  };
  const categoryOptions = [
    { value: "add_category", label: "➕ Add Category" },
    ...Category,
  ];
  return (
    <>
      <Modal show={show} onHide={() => setshowaddsubtaskModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title className="">Add Subtask</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              {" "}
              <Form.Group className="col-6 m-0">
                <Form.Label> Task Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Task Name"
                  id="Taskname"
                  name="Taskname"
                  value={projectfield.Taskname}
                  onChange={handleChange}
                />
                {projecterror.Taskname && (
                  <p className="text-danger">{projecterror.Taskname}</p>
                )}
              </Form.Group>
              <Form.Group className="col-6 m-0">
                <Form.Label> Name</Form.Label>
                <Select
                  options={Member}
                  value={selectedEmployee}
                  onChange={handleEmployeeSelection}
                  placeholder="Select Name"
                />
                {projecterror.Taskassign && (
                  <p className="text-danger">{projecterror.Taskassign}</p>
                )}
              </Form.Group>
            </div>
            <div className="row">
              {" "}
              <Form.Group className="col-6 m-0">
                <Form.Label> Start Date</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Start Date"
                  id="Taskstrt"
                  name="Taskstrt"
                  value={projectfield.Taskstrt}
                  onChange={handleChange}
                />
                {projecterror.Taskstrt && (
                  <p className="text-danger">{projecterror.Taskstrt}</p>
                )}
              </Form.Group>
              <Form.Group className="col-6 m-0">
                <Form.Label> End Date</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="End Date"
                  id="Taskend"
                  name="Taskend"
                  value={projectfield.Taskend}
                  onChange={handleChange}
                />
                {projecterror.Taskend && (
                  <p className="text-danger">{projecterror.Taskend}</p>
                )}
              </Form.Group>
            </div>

            <div className="row ">
              <Form.Group className="col">
                <Form.Label>Priority</Form.Label>
                <Select
                  options={options}
                  onChange={(option) =>
                    setProjectfields((prevFormData) => ({
                      ...prevFormData,
                      TaskPrio: option.value,
                    }))
                  }
                  placeholder=" Priority"
                />
              </Form.Group>
              <Form.Group className="col">
                <Form.Label>Category</Form.Label>
                <Select
                  options={categoryOptions}
                  onChange={handleCategorySelection}
                  placeholder="Select Category"
                />
              </Form.Group>
              <Form.Group className="col">
                <Form.Label>Platform</Form.Label>
                <Select
                  onChange={handlePlatformSelection}
                  options={Platform}
                  placeholder=" Platform"
                />
              </Form.Group>
            </div>
            <div className="row m-0 p-0">
              <Form.Group className="col">
                <Form.Label>Description</Form.Label>
                <textarea
                  className="form-control"
                  type="textarea"
                  name="Taskdesc"
                  value={projectfield.Taskdesc}
                  onChange={handleChange}
                  placeholder="Project Description"
                />
                {projecterror.Taskdesc && (
                  <p className="text-danger">{projecterror.Taskdesc}</p>
                )}
              </Form.Group>
            </div>
            <div className="col-4 ">
              <button
                type="submit"
                // type="button"
                className="btn btn-primary btn-block d-flex justify-content-center align-items-center m-2"
                style={{ height: "2rem", borderRadius: ".3rem" }}
                onClick={handleSubmit}
              >
                Add Task
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <Modal
        show={isAddCategoryModalOpen}
        onHide={() => setAddCategoryModalOpen(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label>Category Name</label>
            <input
              type="text"
              className="form-control"
              value={newCategoryName}
              onChange={(e) => setNewCategoryName(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            size="sm"
            variant="secondary"
            onClick={() => setAddCategoryModalOpen(false)}
          >
            Close
          </Button>
          <Button size="sm" variant="primary" onClick={handleAddCategory}>
            Add Category
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export const AddVenueModal = ({ show, handleClose, onSave, fetchShopData }) => {
  const [formData, setFormData] = useState({
    shop_name: "",
    shop_location: "",
    shop_mobile: "",
    shop_pincode: "",
    owner_name: "",
    owner_mobile: "",
    shop_gst: "",
    shop_type: "",
    shop_details: "",
  });

  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;
  const [formErrors, setFormErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const validateForm = () => {
    const errors = {};
    const requiredFields = {
      shop_name: "Shop name is required",
      shop_location: "Shop location is required",
      shop_mobile: "Shop mobile is required",
      shop_pincode: "Shop pincode is required",
      owner_name: "Owner name is required",
      owner_mobile: "Owner mobile is required",
      shop_gst: "GST number is required",
      shop_type: "Shop type is required",
      shop_details: "Shop details are required",
    };

    for (const field in requiredFields) {
      if (!formData[field]?.trim()) {
        errors[field] = requiredFields[field];
      }
    }
    const mobileRegex = /^[6-9]\d{9}$/;

    if (formData.shop_mobile && !mobileRegex.test(formData.shop_mobile)) {
      errors.shop_mobile = "Enter valid 10-digit shop mobile number";
    }

    if (formData.owner_mobile && !mobileRegex.test(formData.owner_mobile)) {
      errors.owner_mobile = "Enter valid 10-digit owner mobile number";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const raw = JSON.stringify({
        ...formData,
        firmid: user.firm_id,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/AddShopDetails`,
        requestOptions,
      );
      const data = await res.json();

      if (
        data.status === "0" &&
        Array.isArray(data.result) &&
        data.result[0]?.result === "Y"
      ) {
        swal(
          "Success",
          data.result[0].message || "Venue added successfully",
          "success",
        );
        onSave?.(formData);
        handleClose();
        fetchShopData();
        setFormData({
          shop_name: "",
          shop_location: "",
          shop_mobile: "",
          shop_pincode: "",
          owner_name: "",
          owner_mobile: "",
          shop_gst: "",
          shop_type: "",
          shop_details: "",
        });
      } else {
        swal(
          "Error",
          data.result?.[0]?.message || data.msg || "Failed to save venue.",
          "error",
        );
      }
    } catch (error) {
      swal("Error", "Something went wrong while saving venue.", "error");
      console.error("API Error:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  return (
    <Modal show={show} onHide={handleClose} className="venuemodal">
      <Modal.Header closeButton>
        <Modal.Title>Add New Venue</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <div className="row pt-0">
            <Form.Group className=" col-md-6 px-1" controlId="shop_name">
              <Form.Label>Shop Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter shop name"
                name="shop_name"
                value={formData.shop_name}
                onChange={handleChange}
              />
              {formErrors.shop_name && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.shop_name}
                </p>
              )}
            </Form.Group>

            <Form.Group className=" col-md-6 px-1" controlId="owner_name">
              <Form.Label>Owner Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter owner name"
                name="owner_name"
                value={formData.owner_name}
                onChange={handleChange}
              />
              {formErrors.owner_name && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.owner_name}
                </p>
              )}
            </Form.Group>
          </div>

          <div className="row">
            <Form.Group className=" col-md-6 px-1" controlId="shop_mobile">
              <Form.Label>Shop Mobile</Form.Label>
              <Form.Control
                type="tel"
                placeholder="Enter shop mobile"
                name="shop_mobile"
                value={formData.shop_mobile}
                onChange={handleChange}
              />
              {formErrors.shop_mobile && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.shop_mobile}
                </p>
              )}
            </Form.Group>

            <Form.Group className=" col-md-6 px-1" controlId="owner_mobile">
              <Form.Label>Owner Mobile</Form.Label>
              <Form.Control
                type="tel"
                placeholder="Enter owner mobile"
                name="owner_mobile"
                value={formData.owner_mobile}
                onChange={handleChange}
              />
              {formErrors.owner_mobile && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.owner_mobile}
                </p>
              )}
            </Form.Group>
          </div>

          <div className="row">
            <Form.Group className=" col-md-6 px-1" controlId="shop_location">
              <Form.Label>Shop Location</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter shop location"
                name="shop_location"
                value={formData.shop_location}
                onChange={handleChange}
              />
              {formErrors.shop_location && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.shop_location}
                </p>
              )}
            </Form.Group>

            <Form.Group className=" col-md-6 px-1" controlId="shop_pincode">
              <Form.Label>Shop Pincode</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter shop pincode"
                name="shop_pincode"
                value={formData.shop_pincode}
                onChange={handleChange}
              />
              {formErrors.shop_pincode && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.shop_pincode}
                </p>
              )}
            </Form.Group>
          </div>

          <div className="row">
            <Form.Group className=" col-md-6 px-1" controlId="shop_gst">
              <Form.Label>Shop GST</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter GST number"
                name="shop_gst"
                value={formData.shop_gst}
                onChange={handleChange}
              />
              {formErrors.shop_gst && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.shop_gst}
                </p>
              )}
            </Form.Group>

            <Form.Group className=" col-md-6 px-1" controlId="shop_type">
              <Form.Label>Shop Type</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter shop type"
                name="shop_type"
                value={formData.shop_type}
                onChange={handleChange}
              />
              {formErrors.shop_type && (
                <p style={{ color: "red", margin: "4px 0 0" }}>
                  {formErrors.shop_type}
                </p>
              )}
            </Form.Group>
          </div>

          <Form.Group className="mb-3" controlId="shop_details">
            <Form.Label>Shop Details</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter additional details"
              name="shop_details"
              value={formData.shop_details}
              onChange={handleChange}
            />
            {formErrors.shop_details && (
              <p style={{ color: "red", margin: "4px 0 0" }}>
                {formErrors.shop_details}
              </p>
            )}
          </Form.Group>

          <Button variant="primary" type="submit">
            Save Venue
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export const AddEmployeeModal = ({
  show,
  handleClose,
  onSave,
  fetchemployeedata,
}) => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { username, password } = billpunchbasicauth;
  const shiftOptions = [
    { value: "", label: "Select Shift" },
    { value: "Morning", label: "Morning" },
    { value: "Evening", label: "Evening" },
    { value: "Night", label: "Night" },
  ];

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    designation: "",
    joining_date: "",
    dob: "",
    restaurant_id: null,
    shift: "",
    bank_name: "",
    bank_accno: "",
    bank_ifsc: "",
    adhaar_url: "",
    pan_url: "",
    qualification_url: "",
    profile_url: "",
  });

  const [errors, setErrors] = useState({});
  const [shopData, setShopData] = useState([]);

  const validateEmployeeForm = (data) => {
    const errors = {};
    const requiredFields = {
      name: "Name is required",
      mobile: "Mobile number is required",
      email: "Email is required",
      designation: "Designation is required",
      joining_date: "Joining date is required",
      dob: "Date of birth is required",
      restaurant_id: "Restaurant is required",
      shift: "Shift is required",
      bank_name: "Bank name is required",
      bank_accno: "Bank account number is required",
      bank_ifsc: "Bank IFSC code is required",
    };

    for (const field in requiredFields) {
      if (
        !data[field] ||
        (typeof data[field] === "string" && data[field].trim() === "") ||
        (field === "restaurant_id" && data.restaurant_id === null)
      ) {
        errors[field] = requiredFields[field];
      }
    }

    const mobileRegex = /^[6-9]\d{9}$/;
    if (data.mobile && !mobileRegex.test(data.mobile)) {
      errors.mobile = "Enter a valid 10-digit mobile number";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (data.email && !emailRegex.test(data.email)) {
      errors.email = "Enter a valid email address";
    }

    const accNoRegex = /^\d{9,18}$/;
    if (data.bank_accno && !accNoRegex.test(data.bank_accno)) {
      errors.bank_accno = "Enter a valid bank account number (9-18 digits)";
    }

    const ifscRegex = /^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/;
    if (data.bank_ifsc && !ifscRegex.test(data.bank_ifsc)) {
      errors.bank_ifsc = "Enter a valid IFSC code";
    }

    return errors;
  };

  const validateForm = () => {
    const validationErrors = validateEmployeeForm(formData);
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  useEffect(() => {
    if (show) {
      fetchShopData();
      setErrors({});
      setFormData({
        name: "",
        mobile: "",
        email: "",
        designation: "",
        joining_date: "",
        dob: "",
        restaurant_id: null,
        shift: "",
        bank_name: "",
        bank_accno: "",
        bank_ifsc: "",
        adhaar_url: "",
        pan_url: "",
        qualification_url: "",
        profile_url: "",
      });
    }
  }, [show]);

  const fetchShopData = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetRestaurantDetails`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ firmid: user.firm_id }),
        },
      );
      const data = await response.json();

      if (data.status === "0" && Array.isArray(data.data)) {
        setShopData(data.data);
      } else {
        console.error("Failed to fetch shop data", data);
      }
    } catch (error) {
      console.error("Error fetching shop data:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRestaurantChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, restaurant_id: selectedOption }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setTransactionLoaderState(true);

    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const payload = {
        ...formData,
        restaurant_id: formData.restaurant_id?.value ?? null,
        firmid: user.firm_id,
      };

      const raw = JSON.stringify(payload);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/AddConractualEmployee`,
        requestOptions,
      );

      if (res.ok) {
        swal("Success", "Employee saved successfully.", "success");
        onSave?.();
        handleClose();
        fetchemployeedata();
      } else {
        swal("Error", "Failed to save employee.", "error");
      }
    } catch (error) {
      swal("Error", "Something went wrong while saving employee.", "error");
      console.error("API Error:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const restaurantOptions = shopData.map((shop) => ({
    value: shop.id,
    label: `${shop.shop_name} (${shop.shop_location})`,
  }));
  const [isVerifyingBank, setIsVerifyingBank] = useState(false);
  const [verificationMessage, setVerificationMessage] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const handleVerification = async () => {
    setIsVerifyingBank(true);
    const { bank_accno, bank_ifsc } = formData;

    if (!bank_accno || !bank_ifsc) {
      setErrors({
        bank_ifsc: !bank_ifsc ? "IFSC Code is required" : "",
        bank_accno: !bank_accno ? "Account number is required" : "",
      });
      setIsVerifyingBank(false);
      return;
    }

    const requestData = {
      bank_acc_no: bank_accno,
      bank_ifsc_code: bank_ifsc,
      refrence_id: uniqueID(),
    };

    const auth = btoa("admin@billpunch.com:Billpunch@12345");

    try {
      const response = await fetch(
        "https://apiservices.bumppypay.com/api/Verification/bankVerification",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${auth}`,
          },
          body: JSON.stringify(requestData),
        },
      );

      const data = await response.json();

      if (data && data.responseCode === "00") {
        setIsVerified(true);
        setVerificationMessage(
          `Successfully verified as: ${data.data.bank_holder_name}`,
        );
      } else {
        setVerificationMessage("");
      }
    } catch (error) {
      console.error("Error verifying bank details:", error);
      setVerificationMessage("");
    } finally {
      setIsVerifyingBank(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Add New Employee</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate onSubmit={handleSubmit}>
          <Row>
            {/* Name */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="name">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter employee name"
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Mobile */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="mobile">
                <Form.Label>Mobile</Form.Label>
                <Form.Control
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="Enter mobile number"
                  isInvalid={!!errors.mobile}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.mobile}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Email */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email address"
                  isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Designation */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="designation">
                <Form.Label>Designation</Form.Label>
                <Form.Control
                  name="designation"
                  value={formData.designation}
                  onChange={handleChange}
                  placeholder="Enter designation"
                  isInvalid={!!errors.designation}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.designation}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Joining Date */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="joining_date">
                <Form.Label>Joining Date</Form.Label>
                <Form.Control
                  type="date"
                  name="joining_date"
                  value={formData.joining_date}
                  onChange={handleChange}
                  isInvalid={!!errors.joining_date}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.joining_date}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* DOB */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="dob">
                <Form.Label>Date of Birth</Form.Label>
                <Form.Control
                  type="date"
                  name="dob"
                  value={formData.dob}
                  onChange={handleChange}
                  isInvalid={!!errors.dob}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.dob}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Restaurant Select */}
            <Col md={6} className="mb-2">
              <Form.Group controlId="restaurant_id">
                <Form.Label>Restaurant</Form.Label>
                <Select
                  options={restaurantOptions}
                  value={formData.restaurant_id}
                  onChange={handleRestaurantChange}
                  placeholder="Select Restaurant"
                  className={errors.restaurant_id ? "is-invalid" : ""}
                />
                {errors.restaurant_id && (
                  <div className="invalid-feedback d-block">
                    {errors.restaurant_id}
                  </div>
                )}
              </Form.Group>
            </Col>

            <Col md={6} className="mb-2">
              <Form.Group controlId="shift">
                <Form.Label>Shift</Form.Label>
                <Form.Select
                  name="shift"
                  value={formData.shift}
                  onChange={handleChange}
                  isInvalid={!!errors.shift}
                >
                  {shiftOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.shift}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Row className="">
              <Col md={4}>
                <Form.Group controlId="bank_name">
                  <Form.Label>Bank Name</Form.Label>
                  <Form.Control
                    name="bank_name"
                    value={formData.bank_name}
                    onChange={handleChange}
                    placeholder="Enter bank name"
                    isInvalid={!!errors.bank_name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.bank_name}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={4} className="px-1">
                <Form.Group controlId="bank_accno">
                  <Form.Label>Bank Account No.</Form.Label>
                  <Form.Control
                    name="bank_accno"
                    value={formData.bank_accno}
                    onChange={handleChange}
                    placeholder="Enter bank account number"
                    isInvalid={!!errors.bank_accno}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.bank_accno}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group controlId="bank_ifsc">
                  <Form.Label>Bank IFSC</Form.Label>
                  <div className="d-flex">
                    <Form.Control
                      name="bank_ifsc"
                      value={formData.bank_ifsc}
                      onChange={handleChange}
                      placeholder="Enter bank IFSC code"
                      isInvalid={!!errors.bank_ifsc}
                    />
                    <Button
                      className="ms-2"
                      size="sm"
                      onClick={handleVerification}
                      disabled={isVerifyingBank}
                    >
                      {isVerifyingBank ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          />
                          Verifying...
                        </>
                      ) : (
                        "Verify"
                      )}
                    </Button>
                  </div>
                  <Form.Control.Feedback type="invalid">
                    {errors.bank_ifsc}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            {verificationMessage && (
              <div className="text-success m-2" style={{ fontSize: ".9rem" }}>
                {verificationMessage}
              </div>
            )}
            <Col md={6} className="mb-2">
              <Form.Group controlId="adhaar_url">
                <Form.Label>Upload Adhaar Document</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    setFormData((prev) => ({ ...prev, adhaar_url: file.name }));
                  }}
                />
                <Form.Text className="text-muted">
                  {formData.adhaar_url && `Uploaded: ${formData.adhaar_url}`}
                </Form.Text>
              </Form.Group>
            </Col>

            <Col md={6} className="mb-2">
              <Form.Group controlId="pan_url">
                <Form.Label>Upload PAN Document</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    setFormData((prev) => ({ ...prev, pan_url: file.name }));
                  }}
                />
                <Form.Text className="text-muted">
                  {formData.pan_url && `Uploaded: ${formData.pan_url}`}
                </Form.Text>
              </Form.Group>
            </Col>

            <Col md={6} className="mb-2">
              <Form.Group controlId="qualification_url">
                <Form.Label>Upload Qualification Document</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    setFormData((prev) => ({
                      ...prev,
                      qualification_url: file.name,
                    }));
                  }}
                />
                <Form.Text className="text-muted">
                  {formData.qualification_url &&
                    `Uploaded: ${formData.qualification_url}`}
                </Form.Text>
              </Form.Group>
            </Col>

            <Col md={6} className="mb-2">
              <Form.Group controlId="profile_url">
                <Form.Label>Upload Profile Picture</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    setFormData((prev) => ({
                      ...prev,
                      profile_url: file.name,
                    }));
                  }}
                />
                <Form.Text className="text-muted">
                  {formData.profile_url && `Uploaded: ${formData.profile_url}`}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <div className="text-end mt-3">
            <Button variant="secondary" onClick={handleClose} className="me-2">
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save Employee
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export const GeneratePayrollModal = ({ show, onHide }) => {
  const [employeeData, setEmployeeData] = useState([]);
  const [shopData, setShopData] = useState([]);
  const [transactionLoaderState, setTransactionLoaderState] = useState(false);
  const { user } = useContext(GlobalContext);
  const [formData, setFormData] = useState({
    fk_empid: "",
    pay_days: "",
    from_date: "",
    to_date: "",
    amount: "",
    status: "P",
    firmid: user.firm_id,
    restaurant_id: "",
    month: "",
  });

  const { username, password } = billpunchbasicauth;
  const calculateDaysBetween = (fromDate, toDate) => {
    if (!fromDate || !toDate) return 0;
    const from = new Date(fromDate);
    const to = new Date(toDate);
    const diffTime = to - from;
    if (diffTime < 0) return 0;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return diffDays;
  };

  const fetchEmployeeData = async () => {
    try {
      const auth = btoa(`${username}:${password}`);
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetContractEmployees`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${auth}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ firmid: user.firm_id }),
        },
      );
      const data = await res.json();
      if (data.status === "0") setEmployeeData(data.data);
    } catch (err) {
      console.error("Error fetching employee data:", err);
    }
  };

  const fetchShopData = async () => {
    try {
      const auth = btoa(`${username}:${password}`);
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetRestaurantDetails`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${auth}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ firmid: user.firm_id }),
        },
      );
      const data = await res.json();
      if (data.status === "0") setShopData(data.data);
    } catch (err) {
      console.error("Error fetching shop data:", err);
    }
  };

  useEffect(() => {
    if (show) {
      fetchEmployeeData();
      fetchShopData();
    }
  }, [show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTransactionLoaderState(true);

    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const payDays = calculateDaysBetween(
        formData.from_date,
        formData.to_date,
      );

      const payload = {
        ...formData,
        pay_days: payDays,
        amount: Number(formData.amount),
        month: Number(formData.month),
      };

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GenerateRestaurantSalary`,
        requestOptions,
      );

      const data = await res.json();

      if (data.status === "0") {
        const successMessage =
          data.result && data.result.length > 0
            ? data.result[0].message
            : "Success";
        swal("Success", successMessage, "success");
        onHide();
      } else {
        swal("Error", data.msg || "Something went wrong!", "error");
      }
    } catch (error) {
      console.error("Error:", error);
      swal("Error", "Something went wrong!", "error");
    } finally {
      setTransactionLoaderState(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Generate Payroll</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <Form.Group controlId="fk_empid" className="mb-2">
                <Form.Label>Employee</Form.Label>
                <Form.Select
                  name="fk_empid"
                  value={formData.fk_empid}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Employee</option>
                  {employeeData.map((emp) => (
                    <option key={emp.id} value={emp.id}>
                      {emp.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="restaurant_id" className="mb-2">
                <Form.Label>Restaurant</Form.Label>
                <Form.Select
                  name="restaurant_id"
                  value={formData.restaurant_id}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Restaurant</option>
                  {shopData.map((shop) => (
                    <option key={shop.id} value={shop.id}>
                      {shop.shop_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="amount" className="mb-2">
                <Form.Label>Amount</Form.Label>
                <Form.Control
                  type="number"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="month" className="mb-2">
                <Form.Label>Month</Form.Label>
                <Form.Select
                  name="month"
                  value={formData.month}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Month</option>
                  <option value="1">January</option>
                  <option value="2">February</option>
                  <option value="3">March</option>
                  <option value="4">April</option>
                  <option value="5">May</option>
                  <option value="6">June</option>
                  <option value="7">July</option>
                  <option value="8">August</option>
                  <option value="9">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="from_date" className="mb-2">
                <Form.Label>From Date</Form.Label>
                <Form.Control
                  type="date"
                  name="from_date"
                  value={formData.from_date}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="to_date" className="mb-2">
                <Form.Label>To Date</Form.Label>
                <Form.Control
                  type="date"
                  name="to_date"
                  value={formData.to_date}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={onHide}
            disabled={transactionLoaderState}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            disabled={transactionLoaderState}
          >
            {transactionLoaderState ? "Submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
export const LoanModal = ({
  showModal,
  setShowModal,
  loanData,
  handleChange,
  handleSubmit,
  loanTypes,
}) => {
  if (!showModal) return null;

  return (
    <>
      <div className="modal show fade d-block">
        <div className="modal-dialog ">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Apply for Loan</h5>
              <button
                className="btn-close"
                onClick={() => setShowModal(false)}
              ></button>
            </div>

            <div className="modal-body">
              <div className="row g-2 p-0 m-0">
                <div className="col-md-6">
                  <label>Loan Disbursement Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="loan_disbursement_date"
                    value={loanData.loan_disbursement_date}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label>Loan Type</label>

                  <div style={{ position: "relative" }}>
                    <select
                      className="form-control"
                      name="loan_type"
                      value={loanData.loan_type || ""}
                      onChange={handleChange}
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        MozAppearance: "none",
                        paddingRight: "35px",
                      }}
                    >
                      <option value="">Select Loan Type</option>

                      {loanTypes.map((item) => (
                        <option key={item.id} value={item.loan_type}>
                          {item.loan_type}
                        </option>
                      ))}
                    </select>

                    <FaChevronDown
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        fontSize: "14px",
                        color: "#666",
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <label> Loan Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    name="total_loan"
                    value={loanData.total_loan}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label> EMI Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    name="loan_emi_amount"
                    value={loanData.loan_emi_amount}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label>EMI Tenure</label>
                  <input
                    type="number"
                    className="form-control"
                    name="emi_tenure"
                    value={loanData.emi_tenure}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label>Status</label>
                  <select
                    className="form-control"
                    name="is_active"
                    value={loanData.is_active}
                    onChange={handleChange}
                  >
                    <option value={1}>Active</option>
                    <option value={0}>Inactive</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label>Start Date</label>
                  <input
                    type="month"
                    className="form-control"
                    name="start_date"
                    value={
                      loanData.start_date
                        ? loanData.start_date.substring(0, 7)
                        : ""
                    }
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label>End Date</label>
                  <input
                    type="month"
                    className="form-control"
                    name="end_date"
                    value={
                      loanData.end_date ? loanData.end_date.substring(0, 7) : ""
                    }
                    readOnly
                  />
                </div>
                <div className="col-md-12">
                  <label>Remark</label>
                  <textarea
                    className="form-control"
                    name="remark"
                    rows="2"
                    placeholder="Enter remark"
                    value={loanData.remark || ""}
                    onChange={handleChange}
                  ></textarea>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>

              <button className="btn btn-primary" onClick={handleSubmit}>
                Save Loan
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
};
export const LoanemiModal = ({ showModal, setShowModal, selectedLoan }) => {
  const [activeTab, setActiveTab] = useState("emi");

  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const lastEmi = selectedLoan?.item_list?.[selectedLoan?.item_list.length - 1];
  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} size="" centered>
      <Modal.Header closeButton style={{ borderBottom: "1px solid #f1f1f1" }}>
        <Modal.Title style={{ fontWeight: 600 }}>Loan EMI Details</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: "24px" }}>
        {selectedLoan && (
          <div>
            {/* Tabs */}

            <div
              style={{
                display: "flex",
                background: "#f3f4f6",
                borderRadius: "40px",
                padding: "5px",
                marginBottom: "24px",
                width: "270px",
              }}
            >
              <div
                onClick={() => setActiveTab("emi")}
                style={{
                  flex: 1,
                  textAlign: "center",
                  padding: "8px",
                  borderRadius: "40px",
                  cursor: "pointer",
                  background: activeTab === "emi" ? "#111" : "transparent",
                  color: activeTab === "emi" ? "#fff" : "#555",
                  fontWeight: "500",
                  transition: "0.3s",
                }}
              >
                EMI Details
              </div>

              <div
                onClick={() => setActiveTab("transaction")}
                style={{
                  flex: 1,
                  textAlign: "center",
                  padding: "8px",
                  borderRadius: "40px",
                  cursor: "pointer",
                  background:
                    activeTab === "transaction" ? "#111" : "transparent",
                  color: activeTab === "transaction" ? "#fff" : "#555",
                  fontWeight: "500",
                  transition: "0.3s",
                }}
              >
                Transactions
              </div>
            </div>

            {/* EMI TAB */}

            {activeTab === "emi" && (
              <div>
                {/* Next Payment Card */}

                <div
                  style={{
                    border: "1px solid #eee",
                    borderRadius: "14px",
                    padding: "18px",
                    marginBottom: "24px",
                    background: "#fafafa",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
                  }}
                >
                  <div style={{ fontWeight: 600, fontSize: "15px" }}>
                    Payment of ₹{selectedLoan.loan_emi_amount} is due on{" "}
                    {formatDate(lastEmi?.emi_scheduled_date)}
                  </div>

                  <div
                    style={{
                      fontSize: "13px",
                      color: "#888",
                      marginTop: "4px",
                    }}
                  >
                    You have no due EMIs
                  </div>
                </div>

                {/* EMI Timeline */}

                <div style={{ position: "relative" }}>
                  {selectedLoan.item_list?.map((emi, index) => {
                    const isPending = emi.emi_paid_status === "P";

                    return (
                      <div
                        key={emi.emi_id}
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          marginBottom: "22px",
                          position: "relative",
                        }}
                      >
                        {/* Left Timeline */}

                        <div style={{ width: "40px", position: "relative" }}>
                          {/* vertical line */}

                          {index !== selectedLoan.item_list.length - 1 && (
                            <div
                              style={{
                                position: "absolute",
                                top: "20px",
                                left: "9px",
                                width: "2px",
                                height: "40px",
                                background: "#e5e7eb",
                              }}
                            />
                          )}

                          {isPending ? (
                            <div
                              style={{
                                width: "18px",
                                height: "18px",
                                borderRadius: "50%",
                                background: "#d1d5db",
                              }}
                            />
                          ) : (
                            <FaCheckCircle size={20} color="#16a34a" />
                          )}
                        </div>

                        {/* EMI Info */}

                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 500 }}>
                            {emi.emi_month} Month - EMI
                          </div>

                          <div
                            style={{
                              fontSize: "13px",
                              color: "#777",
                              marginTop: "2px",
                            }}
                          >
                            {isPending
                              ? `Due on ${formatDate(emi.emi_scheduled_date)}`
                              : `Paid on ${formatDate(emi.emi_scheduled_date)}`}
                          </div>
                        </div>

                        {/* Amount */}

                        <div
                          style={{
                            fontWeight: 600,
                            color: isPending ? "#444" : "#16a34a",
                          }}
                        >
                          ₹{emi.emi_amount}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* TRANSACTION TAB */}

            {activeTab === "transaction" && (
              <div>
                <div
                  style={{
                    border: "1px solid #eee",
                    borderRadius: "14px",
                    padding: "18px",

                    background: "#fafafa",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
                  }}
                >
                  <div style={{ fontWeight: 600, fontSize: "15px" }}>
                    Payment of ₹{selectedLoan.loan_emi_amount} is due on{" "}
                    {formatDate(lastEmi?.emi_scheduled_date)}
                  </div>

                  <div
                    style={{
                      fontSize: "13px",
                      color: "#888",
                      marginTop: "4px",
                    }}
                  >
                    You have no due EMIs
                  </div>
                </div>
                {selectedLoan.item_list?.map((emi) => {
                  const isPending = emi.emi_paid_status === "P";

                  return (
                    <div
                      key={emi.emi_id}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "14px 0",
                        borderBottom: "1px solid #f1f1f1",
                      }}
                    >
                      <div>
                        <div style={{ fontWeight: 500 }}>
                          {isPending ? "Payment Pending" : "Payment Successful"}
                        </div>

                        <div
                          style={{
                            fontSize: "13px",
                            color: "#777",
                          }}
                        >
                          {formatDate(emi.emi_scheduled_date)}
                        </div>
                      </div>

                      <div
                        style={{
                          fontWeight: 600,
                          color: isPending ? "#444" : "#16a34a",
                        }}
                      >
                        ₹{emi.emi_amount}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
